import React from 'react';
import UnitPageShell from '../../components/shared/UnitPageShell';
import { useTheme } from '../../contexts/ThemeContext';
import { getCardSx, tokens } from '../../theme/tokens';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormHelperText,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  Tab,
  Tabs,
  TextField,
  Typography,
  Snackbar,
  Alert,
  Tooltip
} from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
// HomeIcon entfernt (kein FAB mehr)
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import SaveIcon from '@mui/icons-material/Save';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import ListAltIcon from '@mui/icons-material/ListAlt';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useUnitOverride, updateUnitContent } from '../../services/unitOverridesService';
import FupAnd from '../../components/icons/fup/FupAnd';
import FupOr from '../../components/icons/fup/FupOr';
import FupXor from '../../components/icons/fup/FupXor';
import FupNot from '../../components/icons/fup/FupNot';
import FupNand from '../../components/icons/fup/FupNand';
import FupNor from '../../components/icons/fup/FupNor';
import FupSel from '../../components/icons/fup/FupSel';
import FupSr from '../../components/icons/fup/FupSr';
import FupRs from '../../components/icons/fup/FupRs';
import FupFtrig from '../../components/icons/fup/FupFtrig';
import FupTof from '../../components/icons/fup/FupTof';
import FupTp from '../../components/icons/fup/FupTp';
import FupCtd from '../../components/icons/fup/FupCtd';
import FupCtud from '../../components/icons/fup/FupCtud';
import FupSub from '../../components/icons/fup/FupSub';
import FupMul from '../../components/icons/fup/FupMul';
import FupDiv from '../../components/icons/fup/FupDiv';
import FupLimit from '../../components/icons/fup/FupLimit';
import FupAbs from '../../components/icons/fup/FupAbs';
import FupMin from '../../components/icons/fup/FupMin';
import FupMax from '../../components/icons/fup/FupMax';
import FupGe from '../../components/icons/fup/FupGe';
import FupLe from '../../components/icons/fup/FupLe';
import FupEq from '../../components/icons/fup/FupEq';
import FupNe from '../../components/icons/fup/FupNe';
import FupAvg from '../../components/icons/fup/FupAvg';
import FupScale from '../../components/icons/fup/FupScale';
import FupHyst from '../../components/icons/fup/FupHyst';
import FupLpf from '../../components/icons/fup/FupLpf';
import FupMovAvg from '../../components/icons/fup/FupMovAvg';
import FupMux from '../../components/icons/fup/FupMux';
import FupDemux from '../../components/icons/fup/FupDemux';
import FupPwm from '../../components/icons/fup/FupPwm';
import FupAdd from '../../components/icons/fup/FupAdd';
import FupGt from '../../components/icons/fup/FupGt';
import FupTon from '../../components/icons/fup/FupTon';
import FupPid from '../../components/icons/fup/FupPid';
import FupCtu from '../../components/icons/fup/FupCtu';
import FupInputIcon from '../../components/icons/fup/FupInputIcon';
import FupOutputIcon from '../../components/icons/fup/FupOutputIcon';
const PAGE_ID = 'm10_u2_x1_fup_uebung';

type DataType = 'BOOL' | 'INT' | 'REAL' | 'STRING' | 'TIME';

type FupTask = {
  title: string;
  description: string;
};

type Anchor = {
  id: string;
  blockId: string;
  isInput: boolean;
  name: string;
  dataType: DataType;
  value: unknown;
  negated?: boolean;
};

type FupBlock = {
  id: string;
  type: string;
  inputs: Anchor[];
  outputs: Anchor[];
};

type FupNetwork = {
  id: string;
  title: string;
  blocks: FupBlock[];
};

type Connection = {
  id: string;
  fromAnchorId: string;
  toAnchorId: string;
};

type BlockDefinition = {
  icon: string;
  svgComponent?: React.FC<{ width?: number; height?: number }>;
  inputs: { name: string; dataType: DataType; description?: string }[];
  outputs: { name: string; dataType: DataType; description?: string }[];
  evaluate: (inputs: unknown[], currentOutputs: unknown[]) => unknown[];
};

const createId = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `id-${Math.random().toString(16).slice(2)}-${Date.now()}`;
};

const blockCatalog: Record<string, BlockDefinition> = {
  AND: {
    icon: '/assets/drawable/fup_and.PNG',
    svgComponent: FupAnd,
    inputs: [
      { name: 'IN1', dataType: 'BOOL', description: 'Boolescher Eingang 1' },
      { name: 'IN2', dataType: 'BOOL', description: 'Boolescher Eingang 2' }
    ],
    outputs: [{ name: 'OUT', dataType: 'BOOL', description: 'Ergebnis von AND(IN1..INn)' }],
    evaluate: (inputs) => [inputs.every((v) => Boolean(v))]
  },
  OR: {
    icon: '/assets/drawable/fup_or.PNG',
    svgComponent: FupOr,
    inputs: [
      { name: 'IN1', dataType: 'BOOL', description: 'Boolescher Eingang 1' },
      { name: 'IN2', dataType: 'BOOL', description: 'Boolescher Eingang 2' }
    ],
    outputs: [{ name: 'OUT', dataType: 'BOOL', description: 'Ergebnis von OR(IN1..INn)' }],
    evaluate: (inputs) => [inputs.some((v) => Boolean(v))]
  },
  XOR: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupXor,
    inputs: [
      { name: 'IN1', dataType: 'BOOL', description: 'Boolescher Eingang 1' },
      { name: 'IN2', dataType: 'BOOL', description: 'Boolescher Eingang 2' }
    ],
    outputs: [{ name: 'OUT', dataType: 'BOOL', description: 'Ergebnis von XOR(IN1..INn)' }],
    evaluate: (inputs) => {
      const ones = inputs.reduce<number>((acc, v) => acc + (Boolean(v) ? 1 : 0), 0);
      return [ones % 2 === 1];
    }
  },
  NOT: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupNot,
    inputs: [{ name: 'IN', dataType: 'BOOL', description: 'Boolescher Eingang' }],
    outputs: [{ name: 'OUT', dataType: 'BOOL', description: 'Negation von IN' }],
    evaluate: (inputs) => [!Boolean(inputs[0])]
  },
  NAND: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupNand,
    inputs: [
      { name: 'IN1', dataType: 'BOOL', description: 'Boolescher Eingang 1' },
      { name: 'IN2', dataType: 'BOOL', description: 'Boolescher Eingang 2' }
    ],
    outputs: [{ name: 'OUT', dataType: 'BOOL', description: 'Ergebnis von NOT(AND(IN1..))' }],
    evaluate: (inputs) => [!(inputs.every((v) => Boolean(v)))]
  },
  NOR: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupNor,
    inputs: [
      { name: 'IN1', dataType: 'BOOL', description: 'Boolescher Eingang 1' },
      { name: 'IN2', dataType: 'BOOL', description: 'Boolescher Eingang 2' }
    ],
    outputs: [{ name: 'OUT', dataType: 'BOOL', description: 'Ergebnis von NOT(OR(IN1..))' }],
    evaluate: (inputs) => [!(inputs.some((v) => Boolean(v)))]
  },
  // Rising Edge Detector
  R_TRIG: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupFtrig,
    inputs: [ { name: 'CLK', dataType: 'BOOL', description: 'Takteingang (steigende Flanke)' } ],
    outputs: [
      { name: 'Q', dataType: 'BOOL', description: '1 genau im Flankenzyklus' },
      { name: 'MEM', dataType: 'BOOL', description: 'Intern: letzter CLK' }
    ],
    evaluate: (inputs, outs) => {
      const clk = Boolean(inputs[0]);
      const prev = Boolean(outs?.[1]); // MEM
      const q = clk && !prev;
      return [q, clk];
    }
  },
  F_TRIG: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupFtrig,
    inputs: [ { name: 'CLK', dataType: 'BOOL', description: 'Takteingang (fallende Flanke)' } ],
    outputs: [
      { name: 'Q', dataType: 'BOOL', description: '1 genau im Flankenzyklus' },
      { name: 'MEM', dataType: 'BOOL', description: 'Intern: letzter CLK' }
    ],
    evaluate: (inputs, outs) => {
      const clk = Boolean(inputs[0]);
      const prev = Boolean(outs?.[1]);
      const q = !clk && prev;
      return [q, clk];
    }
  },
  // Zähler Aufwärts (CTU)
  CTU: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupCtu,
    inputs: [
      { name: 'CU', dataType: 'BOOL', description: 'Zählimpuls (steigende Flanke)' },
      { name: 'R', dataType: 'BOOL', description: 'Reset (setzt CV=0)' },
      { name: 'PV', dataType: 'INT', description: 'Vorgabewert (Schwelle für Q)' }
    ],
    outputs: [
      { name: 'Q', dataType: 'BOOL', description: 'TRUE, wenn CV ≥ PV' },
      { name: 'CV', dataType: 'INT', description: 'Zählerstand' },
      { name: 'MEM', dataType: 'BOOL', description: 'Intern: letzte CU' }
    ],
    evaluate: (inputs, outs) => {
      const cu = Boolean(inputs[0]);
      const r = Boolean(inputs[1]);
      const pv = Number(inputs[2]) || 0;
      let cv = Number(outs?.[1]) || 0;
      const prev = Boolean(outs?.[2]);
      const rising = cu && !prev;
      if (r) cv = 0;
      else if (rising) cv = cv + 1;
      const q = cv >= pv && pv > 0;
      return [q, cv, cu];
    }
  },
  // Zähler Abwärts (CTD)
  CTD: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupCtd,
    inputs: [
      { name: 'CD', dataType: 'BOOL', description: 'Zählimpuls abwärts (steigende Flanke)' },
      { name: 'LD', dataType: 'BOOL', description: 'Load: lädt PV in CV' },
      { name: 'PV', dataType: 'INT', description: 'Vorgabewert (Startwert/Schwelle)' }
    ],
    outputs: [
      { name: 'Q', dataType: 'BOOL', description: 'TRUE, wenn CV ≤ 0' },
      { name: 'CV', dataType: 'INT', description: 'Zählerstand' },
      { name: 'MEM', dataType: 'BOOL', description: 'Intern: letzte CD' }
    ],
    evaluate: (inputs, outs) => {
      const cd = Boolean(inputs[0]);
      const ld = Boolean(inputs[1]);
      const pv = Number(inputs[2]) || 0;
      let cv = Number(outs?.[1]) || pv;
      const prev = Boolean(outs?.[2]);
      const rising = cd && !prev;
      if (ld) cv = pv; else if (rising) cv = cv - 1;
      const q = cv <= 0;
      return [q, cv, cd];
    }
  },
  // Zähler Auf-/Ab (CTUD)
  CTUD: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupCtud,
    inputs: [
      { name: 'CU', dataType: 'BOOL', description: 'Zählimpuls aufwärts (steigende Flanke)' },
      { name: 'CD', dataType: 'BOOL', description: 'Zählimpuls abwärts (steigende Flanke)' },
      { name: 'R', dataType: 'BOOL', description: 'Reset (setzt CV=0)' },
      { name: 'PV', dataType: 'INT', description: 'Vorgabewert (Schwelle für QU)' }
    ],
    outputs: [
      { name: 'QU', dataType: 'BOOL', description: 'TRUE, wenn CV ≥ PV' },
      { name: 'QD', dataType: 'BOOL', description: 'TRUE, wenn CV ≤ 0' },
      { name: 'CV', dataType: 'INT', description: 'Zählerstand' },
      { name: 'MEMU', dataType: 'BOOL', description: 'Intern: letzte CU' },
      { name: 'MEMD', dataType: 'BOOL', description: 'Intern: letzte CD' }
    ],
    evaluate: (inputs, outs) => {
      const cu = Boolean(inputs[0]);
      const cd = Boolean(inputs[1]);
      const r = Boolean(inputs[2]);
      const pv = Number(inputs[3]) || 0;
      let cv = Number(outs?.[2]) || 0;
      const pu = Boolean(outs?.[3]);
      const pd = Boolean(outs?.[4]);
      const ru = cu && !pu;
      const rd = cd && !pd;
      if (r) cv = 0;
      else {
        if (ru) cv = cv + 1;
        if (rd) cv = cv - 1;
      }
      const qu = pv > 0 ? cv >= pv : false;
      const qd = cv <= 0;
      return [qu, qd, cv, cu, cd];
    }
  },
  // SR Latch (Set/Reset)
  SR: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupSr,
    inputs: [
      { name: 'S', dataType: 'BOOL', description: 'Setzt Q auf TRUE (falls R=FALSE)' },
      { name: 'R', dataType: 'BOOL', description: 'Setzt Q auf FALSE (falls S=FALSE)' }
    ],
    outputs: [
      { name: 'Q', dataType: 'BOOL', description: 'Latch-Ausgang' },
      { name: 'QN', dataType: 'BOOL', description: 'Negierter Ausgang' },
      { name: 'MEM', dataType: 'BOOL', description: 'Intern: gespeicherter Zustand' }
    ],
    evaluate: (inputs, outs) => {
      const s = Boolean(inputs[0]);
      const r = Boolean(inputs[1]);
      let q = Boolean(outs?.[2]);
      if (s && !r) q = true;
      else if (r && !s) q = false;
      // s&r => letztes q beibehalten
      return [q, !q, q];
    }
  },
  // RS Latch (Reset dominiert)
  RS: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupRs,
    inputs: [
      { name: 'R', dataType: 'BOOL', description: 'Reset dominiert: setzt Q auf FALSE' },
      { name: 'S', dataType: 'BOOL', description: 'Setzt Q auf TRUE (falls R=FALSE)' }
    ],
    outputs: [
      { name: 'Q', dataType: 'BOOL', description: 'Latch-Ausgang' },
      { name: 'QN', dataType: 'BOOL', description: 'Negierter Ausgang' },
      { name: 'MEM', dataType: 'BOOL', description: 'Intern: gespeicherter Zustand' }
    ],
    evaluate: (inputs, outs) => {
      const r = Boolean(inputs[0]);
      const s = Boolean(inputs[1]);
      let q = Boolean(outs?.[2]);
      if (r && !s) q = false;
      else if (s && !r) q = true;
      // r&s => Reset dominiert
      if (r && s) q = false;
      return [q, !q, q];
    }
  },
  // ADD für REAL/INT
  ADD: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupAdd,
    inputs: [
      { name: 'IN1', dataType: 'REAL', description: 'Summand 1' },
      { name: 'IN2', dataType: 'REAL', description: 'Summand 2' }
    ],
    outputs: [
      { name: 'OUT', dataType: 'REAL', description: 'Summe' }
    ],
    evaluate: (inputs) => [Number(inputs[0]) + Number(inputs[1])]
  },
  // Vergleich größer als
  GT: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupGt,
    inputs: [
      { name: 'IN1', dataType: 'REAL', description: 'Operand links' },
      { name: 'IN2', dataType: 'REAL', description: 'Operand rechts' }
    ],
    outputs: [
      { name: 'OUT', dataType: 'BOOL', description: 'TRUE, wenn IN1 > IN2' }
    ],
    evaluate: (inputs) => [Number(inputs[0]) > Number(inputs[1])]
  },
  GE: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupGe,
    inputs: [
      { name: 'IN1', dataType: 'REAL', description: 'Linker Operand' },
      { name: 'IN2', dataType: 'REAL', description: 'Rechter Operand' }
    ],
    outputs: [
      { name: 'OUT', dataType: 'BOOL', description: 'TRUE, wenn IN1 ≥ IN2' }
    ],
    evaluate: (inputs) => [Number(inputs[0]) >= Number(inputs[1])]
  },
  LE: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupLe,
    inputs: [
      { name: 'IN1', dataType: 'REAL', description: 'Linker Operand' },
      { name: 'IN2', dataType: 'REAL', description: 'Rechter Operand' }
    ],
    outputs: [
      { name: 'OUT', dataType: 'BOOL', description: 'TRUE, wenn IN1 ≤ IN2' }
    ],
    evaluate: (inputs) => [Number(inputs[0]) <= Number(inputs[1])]
  },
  EQ: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupEq,
    inputs: [
      { name: 'IN1', dataType: 'REAL', description: 'Linker Operand' },
      { name: 'IN2', dataType: 'REAL', description: 'Rechter Operand' }
    ],
    outputs: [
      { name: 'OUT', dataType: 'BOOL', description: 'TRUE, wenn IN1 = IN2' }
    ],
    evaluate: (inputs) => [Number(inputs[0]) === Number(inputs[1])]
  },
  NE: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupNe,
    inputs: [
      { name: 'IN1', dataType: 'REAL', description: 'Linker Operand' },
      { name: 'IN2', dataType: 'REAL', description: 'Rechter Operand' }
    ],
    outputs: [
      { name: 'OUT', dataType: 'BOOL', description: 'TRUE, wenn IN1 ≠ IN2' }
    ],
    evaluate: (inputs) => [Number(inputs[0]) !== Number(inputs[1])]
  },
  // Einfache TON: benötigt DT (s) als Taktinkrement
  TON: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupTon,
    inputs: [
      { name: 'IN', dataType: 'BOOL', description: 'Enable (Start Timer)' },
      { name: 'PT', dataType: 'REAL', description: 'Vorgabewert Zeit (s)' },
      { name: 'DT', dataType: 'REAL', description: 'Zeitschritt pro Zyklus (s)' }
    ],
    outputs: [
      { name: 'Q', dataType: 'BOOL', description: 'TRUE, wenn ET ≥ PT' },
      { name: 'ET', dataType: 'REAL', description: 'Verstrichene Zeit (s)' }
    ],
    evaluate: (inputs, outs) => {
      const en = Boolean(inputs[0]);
      const pt = Math.max(0, Number(inputs[1]) || 0);
      const dt = Math.max(0, Number(inputs[2]) || 0.12);
      let et = Number(outs?.[1]) || 0;
      if (en) et = Math.min(pt, et + dt);
      else et = 0;
      const q = en && et >= pt && pt > 0;
      return [q, et];
    }
  },
  // Ausschaltverzögerung
  TOF: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupTof,
    inputs: [
      { name: 'IN', dataType: 'BOOL', description: 'Enable (TRUE hält Q für PT)' },
      { name: 'PT', dataType: 'REAL', description: 'Vorgabewert Zeit (s)' },
      { name: 'DT', dataType: 'REAL', description: 'Zeitschritt pro Zyklus (s)' }
    ],
    outputs: [
      { name: 'Q', dataType: 'BOOL', description: 'TRUE bis ET ≥ PT nach IN=FALSE' },
      { name: 'ET', dataType: 'REAL', description: 'Verstrichene Zeit (s)' }
    ],
    evaluate: (inputs, outs) => {
      const en = Boolean(inputs[0]);
      const pt = Math.max(0, Number(inputs[1]) || 0);
      const dt = Math.max(0, Number(inputs[2]) || 0.12);
      let et = Number(outs?.[1]) || 0;
      let q = Boolean(outs?.[0]) || false;
      if (en) { et = 0; q = true; }
      else { et = Math.min(pt, et + dt); q = et < pt; }
      return [q, et];
    }
  },
  // Impulsgeber (Monoflop)
  TP: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupTp,
    inputs: [
      { name: 'IN', dataType: 'BOOL', description: 'Trigger (steigende Flanke startet Impuls)' },
      { name: 'PT', dataType: 'REAL', description: 'Impulsdauer (s)' },
      { name: 'DT', dataType: 'REAL', description: 'Zeitschritt pro Zyklus (s)' }
    ],
    outputs: [
      { name: 'Q', dataType: 'BOOL', description: 'Impuls-Ausgang' },
      { name: 'ET', dataType: 'REAL', description: 'Verstrichene Zeit (s)' },
      { name: 'MEM', dataType: 'BOOL', description: 'Intern: letzter IN' }
    ],
    evaluate: (inputs, outs) => {
      const en = Boolean(inputs[0]);
      const pt = Math.max(0, Number(inputs[1]) || 0);
      const dt = Math.max(0, Number(inputs[2]) || 0.12);
      let et = Number(outs?.[1]) || 0;
      const prev = Boolean(outs?.[2]);
      const rising = en && !prev;
      let q = Boolean(outs?.[0]) || false;
      if (rising) { q = true; et = 0; }
      if (q) {
        et = Math.min(pt, et + dt);
        if (et >= pt) q = false;
      }
      return [q, et, en];
    }
  },
  // Einfacher PID: OUT = Kp*e + I + Kd*(e-prev)/DT; I = I + Ki*e*DT
  PID: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupPid,
    inputs: [
      { name: 'SP', dataType: 'REAL', description: 'Sollwert' },
      { name: 'PV', dataType: 'REAL', description: 'Istwert' },
      { name: 'Kp', dataType: 'REAL', description: 'Proportionalanteil' },
      { name: 'Ki', dataType: 'REAL', description: 'Integralanteil' },
      { name: 'Kd', dataType: 'REAL', description: 'Differentialanteil' },
      { name: 'DT', dataType: 'REAL', description: 'Zeitschritt (s)' }
    ],
    outputs: [
      { name: 'OUT', dataType: 'REAL', description: 'Stellgröße' },
      { name: 'I', dataType: 'REAL', description: 'Integralspeicher' },
      { name: 'E_PREV', dataType: 'REAL', description: 'Vorheriger Fehler' }
    ],
    evaluate: (inputs, outs) => {
      const sp = Number(inputs[0]) || 0;
      const pv = Number(inputs[1]) || 0;
      const kp = Number(inputs[2]) || 0;
      const ki = Number(inputs[3]) || 0;
      const kd = Number(inputs[4]) || 0;
      const dt = Math.max(1e-6, Number(inputs[5]) || 0.12);
      const e = sp - pv;
      let I = Number(outs?.[1]) || 0;
      const ePrev = Number(outs?.[2]) || 0;
      I = I + ki * e * dt;
      const D = (e - ePrev) / dt;
      const out = kp * e + I + kd * D;
      return [out, I, e];
    }
  },
  SUB: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupSub,
    inputs: [
      { name: 'IN1', dataType: 'REAL', description: 'Minuend' },
      { name: 'IN2', dataType: 'REAL', description: 'Subtrahend' }
    ],
    outputs: [ { name: 'OUT', dataType: 'REAL', description: 'Differenz (IN1 - IN2)' } ],
    evaluate: (inputs) => [Number(inputs[0]) - Number(inputs[1])]
  },
  MUL: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupMul,
    inputs: [
      { name: 'IN1', dataType: 'REAL', description: 'Faktor 1' },
      { name: 'IN2', dataType: 'REAL', description: 'Faktor 2' }
    ],
    outputs: [ { name: 'OUT', dataType: 'REAL', description: 'Produkt' } ],
    evaluate: (inputs) => [Number(inputs[0]) * Number(inputs[1])]
  },
  DIV: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupDiv,
    inputs: [
      { name: 'IN1', dataType: 'REAL', description: 'Dividend' },
      { name: 'IN2', dataType: 'REAL', description: 'Divisor' }
    ],
    outputs: [ { name: 'OUT', dataType: 'REAL', description: 'Quotient (0 bei Divisor=0)' } ],
    evaluate: (inputs) => {
      const a = Number(inputs[0]);
      const b = Number(inputs[1]);
      return [b === 0 ? 0 : a / b];
    }
  },
  LIMIT: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupLimit,
    inputs: [
      { name: 'IN', dataType: 'REAL', description: 'Eingangswert' },
      { name: 'MIN', dataType: 'REAL', description: 'Untergrenze' },
      { name: 'MAX', dataType: 'REAL', description: 'Obergrenze' }
    ],
    outputs: [ { name: 'OUT', dataType: 'REAL', description: 'Begrenzter Wert' } ],
    evaluate: (inputs) => {
      const x = Number(inputs[0]);
      const min = Number(inputs[1]);
      const max = Number(inputs[2]);
      return [Math.max(min, Math.min(max, x))];
    }
  },
  ABS: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupAbs,
    inputs: [ { name: 'IN', dataType: 'REAL', description: 'Eingangswert' } ],
    outputs: [ { name: 'OUT', dataType: 'REAL', description: 'Betrag' } ],
    evaluate: (inputs) => [Math.abs(Number(inputs[0]))]
  },
  MIN: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupMin,
    inputs: [ { name: 'IN1', dataType: 'REAL', description: 'Operand 1' }, { name: 'IN2', dataType: 'REAL', description: 'Operand 2' } ],
    outputs: [ { name: 'OUT', dataType: 'REAL', description: 'Minimum' } ],
    evaluate: (inputs) => [Math.min(Number(inputs[0]), Number(inputs[1]))]
  },
  MAX: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupMax,
    inputs: [ { name: 'IN1', dataType: 'REAL', description: 'Operand 1' }, { name: 'IN2', dataType: 'REAL', description: 'Operand 2' } ],
    outputs: [ { name: 'OUT', dataType: 'REAL', description: 'Maximum' } ],
    evaluate: (inputs) => [Math.max(Number(inputs[0]), Number(inputs[1]))]
  },
  AVG: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupAvg,
    inputs: [ { name: 'IN1', dataType: 'REAL', description: 'Operand 1' }, { name: 'IN2', dataType: 'REAL', description: 'Operand 2' } ],
    outputs: [ { name: 'OUT', dataType: 'REAL', description: 'Durchschnitt (arithm.)' } ],
    evaluate: (inputs) => [(Number(inputs[0]) + Number(inputs[1])) / 2]
  },
  SCALE: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupScale,
    inputs: [
      { name: 'IN', dataType: 'REAL', description: 'Eingangswert' },
      { name: 'IN_MIN', dataType: 'REAL', description: 'Minimaler Eingangswert' },
      { name: 'IN_MAX', dataType: 'REAL', description: 'Maximaler Eingangswert' },
      { name: 'OUT_MIN', dataType: 'REAL', description: 'Minimaler Ausgangswert' },
      { name: 'OUT_MAX', dataType: 'REAL', description: 'Maximaler Ausgangswert' }
    ],
    outputs: [ { name: 'OUT', dataType: 'REAL', description: 'Skalierter Wert' } ],
    evaluate: (inputs) => {
      const x = Number(inputs[0]);
      const inMin = Number(inputs[1]);
      const inMax = Number(inputs[2]);
      const outMin = Number(inputs[3]);
      const outMax = Number(inputs[4]);
      if (inMax === inMin) return [outMin];
      const t = (x - inMin) / (inMax - inMin);
      return [outMin + t * (outMax - outMin)];
    }
  },
  HYST: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupHyst,
    inputs: [ { name: 'IN', dataType: 'REAL', description: 'Eingangswert' }, { name: 'TH_ON', dataType: 'REAL', description: 'Einschalt-Schwelle' }, { name: 'TH_OFF', dataType: 'REAL', description: 'Ausschalt-Schwelle' } ],
    outputs: [ { name: 'Q', dataType: 'BOOL', description: 'Schaltzustand' }, { name: 'MEM', dataType: 'BOOL', description: 'Intern: letzter Zustand' } ],
    evaluate: (inputs, outs) => {
      const x = Number(inputs[0]);
      const thOn = Number(inputs[1]);
      const thOff = Number(inputs[2]);
      let q = Boolean(outs?.[1]);
      if (x >= thOn) q = true; else if (x <= thOff) q = false;
      return [q, q];
    }
  },
  LPF: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupLpf,
    inputs: [ { name: 'IN', dataType: 'REAL', description: 'Eingangswert' }, { name: 'TAU', dataType: 'REAL', description: 'Zeitkonstante' }, { name: 'DT', dataType: 'REAL', description: 'Zeitschritt (s)' } ],
    outputs: [ { name: 'OUT', dataType: 'REAL', description: 'Gefilterter Wert' }, { name: 'STATE', dataType: 'REAL', description: 'Interner Zustand' } ],
    evaluate: (inputs, outs) => {
      const x = Number(inputs[0]) || 0;
      const tau = Number(inputs[1]) || 0;
      const dt = Math.max(1e-6, Number(inputs[2]) || 0.12);
      let y = Number(outs?.[1]) || 0;
      if (tau <= 0) y = x; else y = y + (dt / tau) * (x - y);
      return [y, y];
    }
  },
  MOVAVG: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupMovAvg,
    inputs: [ { name: 'IN', dataType: 'REAL', description: 'Eingangswert' }, { name: 'N', dataType: 'INT', description: 'Fenstergröße' } ],
    outputs: [ { name: 'OUT', dataType: 'REAL', description: 'Gleitender Mittelwert' }, { name: 'SUM', dataType: 'REAL', description: 'Zwischensumme' }, { name: 'COUNT', dataType: 'INT', description: 'Samples im Fenster' } ],
    evaluate: (inputs, outs) => {
      const x = Number(inputs[0]) || 0;
      const n = Math.max(1, Number(inputs[1]) || 1);
      let sum = Number(outs?.[1]) || 0;
      let count = Number(outs?.[2]) || 0;
      sum += x;
      count += 1;
      if (count > n) { sum = x; count = 1; }
      const out = sum / count;
      return [out, sum, count];
    }
  },
  MUX4: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupMux,
    inputs: [
      { name: 'S0', dataType: 'BOOL', description: 'Selektor Bit 0' },
      { name: 'S1', dataType: 'BOOL', description: 'Selektor Bit 1' },
      { name: 'IN0', dataType: 'REAL', description: 'Eingang 0' },
      { name: 'IN1', dataType: 'REAL', description: 'Eingang 1' },
      { name: 'IN2', dataType: 'REAL', description: 'Eingang 2' },
      { name: 'IN3', dataType: 'REAL', description: 'Eingang 3' }
    ],
    outputs: [ { name: 'OUT', dataType: 'REAL', description: 'Ausgewählter Eingang' } ],
    evaluate: (inputs) => {
      const s0 = Boolean(inputs[0]);
      const s1 = Boolean(inputs[1]);
      const idx = (s1 ? 2 : 0) + (s0 ? 1 : 0);
      const val = Number(inputs[2 + idx]) || 0;
      return [val];
    }
  },
  DEMUX4: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupDemux,
    inputs: [ { name: 'S0', dataType: 'BOOL', description: 'Selektor Bit 0' }, { name: 'S1', dataType: 'BOOL', description: 'Selektor Bit 1' }, { name: 'IN', dataType: 'BOOL', description: 'Eingang' } ],
    outputs: [ { name: 'OUT0', dataType: 'BOOL', description: 'Ausgang 0' }, { name: 'OUT1', dataType: 'BOOL', description: 'Ausgang 1' }, { name: 'OUT2', dataType: 'BOOL', description: 'Ausgang 2' }, { name: 'OUT3', dataType: 'BOOL', description: 'Ausgang 3' } ],
    evaluate: (inputs) => {
      const s0 = Boolean(inputs[0]);
      const s1 = Boolean(inputs[1]);
      const val = Boolean(inputs[2]);
      const idx = (s1 ? 2 : 0) + (s0 ? 1 : 0);
      return [0,1,2,3].map(i => (i === idx ? val : false)) as unknown as unknown[];
    }
  },
  PWM: {
    icon: '/assets/drawable/zzz_help.png',
    svgComponent: FupPwm,
    inputs: [ { name: 'DUTY', dataType: 'REAL', description: 'Tastgrad 0..1' }, { name: 'PERIOD', dataType: 'REAL', description: 'Periode (s)' }, { name: 'DT', dataType: 'REAL', description: 'Zeitschritt (s)' } ],
    outputs: [ { name: 'OUT', dataType: 'BOOL', description: 'PWM-Signal' }, { name: 'PHASE', dataType: 'REAL', description: 'Aktuelle Phase' } ],
    evaluate: (inputs, outs) => {
      const duty = Math.max(0, Math.min(1, Number(inputs[0]) || 0));
      const period = Math.max(1e-6, Number(inputs[1]) || 1);
      const dt = Math.max(1e-6, Number(inputs[2]) || 0.12);
      let phase = Number(outs?.[1]) || 0;
      phase += dt;
      if (phase >= period) phase -= period;
      const q = phase < duty * period;
      return [q, phase];
    }
  },
  SEL: {
    icon: '/assets/drawable/fup_sel.PNG',
    svgComponent: FupSel,
    inputs: [
      { name: 'G', dataType: 'BOOL', description: 'Gate/Selector (0→IN0, 1→IN1)' },
      { name: 'IN0', dataType: 'BOOL', description: 'Eingang 0' },
      { name: 'IN1', dataType: 'BOOL', description: 'Eingang 1' }
    ],
    outputs: [{ name: 'OUT', dataType: 'BOOL', description: 'Ausgewählter Eingang' }],
    evaluate: (inputs) => {
      const gate = Boolean(inputs[0]);
      return [gate ? Boolean(inputs[2]) : Boolean(inputs[1])];
    }
  }
};

const taskList: FupTask[] = [
  {
    title: 'Motorsteuerung',
    description: 'Motor (Q1) läuft wenn Taster I1=TRUE UND Sicherheit I2=TRUE. Verwende AND-Block.'
  },
  {
    title: 'Wechselschaltung',
    description: 'Zwei Taster I1, I2 schalten Lampe Q1 wechselseitig (nur eine Taste pro Zustand). Verwende XOR-Block.'
  },
  {
    title: 'Belüftung',
    description: 'Ventilator Q1 läuft, wenn Automatik I1=TRUE UND KEINE Störung (I2=FALSE UND I3=FALSE). Verwende AND + 2x NOT (Negationen).'
  },
  {
    title: 'Nachtbetrieb',
    description: 'Q1=TRUE wenn Nachtbetrieb I1=TRUE ODER Freigabe I2=TRUE. Verwende OR-Block.'
  },
  {
    title: 'Pumpenfreigabe',
    description: 'Pumpe Q1 läuft nur wenn Wasserstand I1=TRUE UND Störung I2=FALSE. Verwende AND mit Negation auf I2.'
  },
  {
    title: 'Lichtbrücke',
    description: 'Beleuchtung Q1: Präsenz I1=TRUE UND Lichtsensor I2=TRUE (beide Bedingungen). Verwende AND-Block (keine Komparatoren nötig).'
  },
  {
    title: 'Heizanforderung',
    description: 'Heizkreis Q1: (Anforderung I1 ODER Frostschutz I2) UND kein Wartung (I3=FALSE). Verwende OR + AND, mit Negation auf I3.'
  },
  {
    title: 'Sicherheitslogik',
    description: 'Q1=TRUE nur wenn ALLE drei Eingänge I1, I2, I3=TRUE. Verwende AND mit 3 Eingängen (erweiterbar).'
  },
  {
    title: 'Manuell/Auto',
    description: 'Q1 folgt dem Automatik-Signal I3 wenn Modus I1=TRUE, sonst folgt Q1 dem Hand-Signal I4. Verwende SEL-Block (Selector).'
  },
  {
    title: 'Alarm',
    description: 'Alarm Q1 wird ausgelöst wenn (Störung I1 ODER I2)=TRUE UND Quittierung I3=FALSE. Verwende OR + AND mit NOT auf I3.'
  },
  {
    title: 'Schwellenwert',
    description: 'Q1=TRUE wenn reale Zahl I1 > reale Zahl I2. Verwende GT-Komparator (lege I1, I2 als REAL an).'
  },
  {
    title: '2-von-3 Mehrheit',
    description: 'Q1=TRUE wenn mindestens 2 von 3 Eingängen I1, I2, I3 sind TRUE. Logik: (I1 AND I2) OR (I1 AND I3) OR (I2 AND I3).'
  },
  {
    title: 'Gleichheit',
    description: 'Q1=TRUE wenn I1 und I2 den gleichen Wert haben (beide TRUE oder beide FALSE). Nutze EQ-Block oder (NOT XOR).'
  },
  {
    title: 'Selektor',
    description: 'I1 wählt Eingang: bei I1=FALSE → Q1 bekommt I2, bei I1=TRUE → Q1 bekommt I3. Verwende SEL-Block.'
  },
  {
    title: 'Verriegelung 4-fach',
    description: 'Q1=TRUE nur wenn I1=TRUE und alle anderen I2, I3, I4 sind FALSE. Verwende AND mit NOT auf I2, I3, I4.'
  },
  {
    title: 'Temperaturfenster',
    description: 'Q1=TRUE wenn Wert I1 im Bereich [I2, I3] liegt (I1≥I2 UND I1≤I3). Verwende GE und LE mit AND. Lege I1, I2, I3 als REAL an!'
  },
  {
    title: '3-von-4 Mehrheit',
    description: 'Q1=TRUE wenn mind. 3 von 4 Eingängen I1, I2, I3, I4 sind TRUE. Kombiniere mehrere AND/OR: (I1 AND I2 AND I3) OR (I1 AND I2 AND I4) etc.'
  },
  {
    title: 'Ungerade Anzahl',
    description: 'Q1=TRUE wenn eine ODD Anzahl der Eingänge I1, I2, I3, I4 den Wert TRUE hat (1 oder 3 TRUE). Verkette zwei XOR-Blöcke hintereinander: (I1 XOR I2) XOR (I3 XOR I4).'
  },
  {
    title: 'Sammelalarm',
    description: 'Q1=(I1 ODER I2 ODER I3) UND kein Quittierung (I4=FALSE). Verwende OR + AND mit NOT auf I4.'
  },
  {
    title: 'Freigabe mit Backup',
    description: 'Q1 ist TRUE, wenn: (I1=TRUE) ODER (I2 UND I3 beide TRUE), aber nur wenn I4=FALSE. Schreibe: (I1 OR (I2 AND I3)) AND NOT I4.'
  }
];

const networkTitle = (index: number) => `Netzwerk ${index + 1}`;

const createAnchor = (blockId: string, isInput: boolean, name: string, dataType: DataType, value: unknown): Anchor => ({
  id: createId(),
  blockId,
  isInput,
  name,
  dataType,
  value,
  negated: false
});

const createBlock = (type: string): FupBlock => {
  const id = createId();
  const definition = blockCatalog[type];
  const inputs = (definition?.inputs ?? []).map((input) =>
    createAnchor(id, true, input.name, input.dataType, input.dataType === 'BOOL' ? false : 0)
  );
  const outputs = (definition?.outputs ?? []).map((output) =>
    createAnchor(id, false, output.name, output.dataType, output.dataType === 'BOOL' ? false : 0)
  );
  return { id, type, inputs, outputs };
};

const createNetwork = (index: number): FupNetwork => ({
  id: createId(),
  title: networkTitle(index),
  blocks: []
});

// Erweiterbare Blocktypen (Eingänge dynamisch add/remove)
const EXPANDABLE_TYPES = new Set<string>(['AND', 'OR', 'XOR', 'NAND', 'NOR']);

const estimateBlockHeight = (block: FupBlock) => {
  const base = block.type === 'INPUT' || block.type === 'OUTPUT' ? 86 : 92;
  const lines = Math.max(block.inputs.length, block.outputs.length);
  // Mehr Platz für jeden Input/Output (28 statt 22) und Padding hinzufügen
  return base + lines * 28 + 16;
};

type NetworkLayout = { positions: Map<string, { x: number; y: number }>; height: number };

// Neue dynamische Layout-Logik: Layer (Tiefe) via topologische Bewertung.
// Regeln:
// - INPUT immer Spalte 0
// - Funktionsblock-Spalte = 1 + max(Tiefe seiner Vorgänger) oder 1 wenn keine Vorgänger
// - OUTPUT Spalte = max(Funktionsblock-Tiefe) + 1
// - Blöcke innerhalb einer Spalte stabil sortiert: zuerst mit weniger Eingängen / Vorgängern
const computeNetworkLayout = (network: FupNetwork, connections: Connection[]): NetworkLayout => {
  const COLUMN_WIDTH = 260;
  const GAP_Y = 24;
  const START_X = 20;
  const START_Y = 20;

  const blocks = network.blocks;
  const depthMap = new Map<string, number>();

  // Vorgänger-Mapping aufbauen
  const predecessors = new Map<string, Set<string>>(); // blockId -> set of predecessor blockIds
  blocks.forEach((b) => predecessors.set(b.id, new Set()));
  connections.forEach((c) => {
    const targetBlock = blocks.find((b) => b.inputs.some((a) => a.id === c.toAnchorId));
    const sourceBlock = blocks.find((b) => b.outputs.some((a) => a.id === c.fromAnchorId));
    if (targetBlock && sourceBlock && targetBlock.id !== sourceBlock.id) {
      predecessors.get(targetBlock.id)?.add(sourceBlock.id);
    }
  });

  // Initialtiefe setzen
  blocks.forEach((b) => {
    if (b.type === 'INPUT') depthMap.set(b.id, 0);
    else if (b.type === 'OUTPUT') depthMap.set(b.id, 0); // vorläufig, wird später angepasst
    else depthMap.set(b.id, 1);
  });

  // Iterativ aktualisieren bis stabil oder max Durchläufe
  for (let pass = 0; pass < 32; pass += 1) {
    let changed = false;
    for (const b of blocks) {
      if (b.type === 'INPUT' || b.type === 'OUTPUT') continue;
      const preds = predecessors.get(b.id)!;
      let newDepth = 1;
      if (preds.size > 0) {
        let maxPred = 0;
        preds.forEach((pid) => {
          const pd = depthMap.get(pid) ?? 0;
          maxPred = Math.max(maxPred, pd);
        });
        newDepth = maxPred + 1;
      }
      if (newDepth !== depthMap.get(b.id)) {
        depthMap.set(b.id, newDepth);
        changed = true;
      }
    }
    if (!changed) break;
  }

  // Max Tiefe für Funktionsblöcke bestimmen
  const maxFuncDepth = Math.max(0, ...blocks.filter((b) => b.type !== 'INPUT' && b.type !== 'OUTPUT').map((b) => depthMap.get(b.id) || 1));

  // OUTPUT Tiefe festlegen
  blocks.forEach((b) => {
    if (b.type === 'OUTPUT') depthMap.set(b.id, maxFuncDepth + 1);
  });

  // Spalten gruppieren
  const columns: Record<number, FupBlock[]> = {};
  blocks.forEach((b) => {
    const d = depthMap.get(b.id) ?? 0;
    if (!columns[d]) columns[d] = [];
    columns[d].push(b);
  });

  // Sortierung innerhalb der Spalte: zuerst weniger Vorgänger, dann Name stabil
  Object.values(columns).forEach((arr) => {
    arr.sort((a, b) => {
      const pa = predecessors.get(a.id)?.size || 0;
      const pb = predecessors.get(b.id)?.size || 0;
      if (pa !== pb) return pa - pb;
      return a.id.localeCompare(b.id);
    });
  });

  // Positionen berechnen
  const positions = new Map<string, { x: number; y: number }>();
  let totalHeight = 0;
  const sortedCols = Object.keys(columns).map((n) => Number(n)).sort((a, b) => a - b);
  sortedCols.forEach((colIndex, visualIndex) => {
    const x = START_X + visualIndex * COLUMN_WIDTH;
    let y = START_Y;
    for (const b of columns[colIndex]) {
      positions.set(b.id, { x, y });
      y += estimateBlockHeight(b) + GAP_Y;
    }
    totalHeight = Math.max(totalHeight, y);
  });

  return { positions, height: totalHeight + START_Y };
};

const resolveInputValue = (
  anchorId: string,
  connections: Connection[],
  anchorValueMap: Map<string, unknown>,
  anchorFromId: (id: string) => Anchor | undefined
) => {
  const connection = connections.find((entry) => entry.toAnchorId === anchorId);
  if (!connection) return anchorValueMap.get(anchorId);
  let value = anchorValueMap.get(connection.fromAnchorId);
  const targetAnchor = anchorFromId(anchorId);
  const sourceAnchor = anchorFromId(connection.fromAnchorId);
  if (targetAnchor?.negated && targetAnchor.dataType === 'BOOL') {
    value = !Boolean(value);
  }
  if (sourceAnchor?.negated && sourceAnchor.dataType === 'BOOL') {
    value = !Boolean(value);
  }
  return value;
};

const evaluateNetworks = (
  networks: FupNetwork[],
  connections: Connection[],
  globalValues: Map<string, unknown>,
  iterationLimit = 32
) => {
  const anchorValueMap = new Map<string, unknown>();
  const anchorFromId = (id: string): Anchor | undefined => {
    for (const network of networks) {
      for (const block of network.blocks) {
        const anchor = [...block.inputs, ...block.outputs].find((item) => item.id === id);
        if (anchor) return anchor;
      }
    }
    return undefined;
  };
  for (const network of networks) {
    for (const block of network.blocks) {
      for (const anchor of [...block.inputs, ...block.outputs]) {
        anchorValueMap.set(anchor.id, anchor.value);
      }
    }
  }

  // Globale INPUT-Werte initialisieren
  for (const network of networks) {
    for (const block of network.blocks) {
      if (block.type === 'INPUT') {
        const output = block.outputs[0];
        if (output?.name) {
          const globalValue = globalValues.get(output.name);
          if (typeof globalValue !== 'undefined') {
            anchorValueMap.set(output.id, globalValue);
          }
        }
      }
    }
  }

  let changed = false;
  let cycle = 0;
  do {
    changed = false;
    cycle += 1;

    for (const network of networks) {
      for (const block of network.blocks) {
        if (block.type === 'INPUT') {
          // INPUT-Blöcke schreiben in globale Variablen
          const output = block.outputs[0];
          if (output?.name) {
            const currentValue = anchorValueMap.get(output.id);
            const globalValue = globalValues.get(output.name);
            if (currentValue !== globalValue) {
              globalValues.set(output.name, currentValue);
              changed = true;
            }
          }
          continue;
        }
        if (block.type === 'OUTPUT') {
          // OUTPUT-Blöcke lesen von globalen Variablen
          const input = block.inputs[0];
          if (input?.name) {
            const globalValue = globalValues.get(input.name);
            if (typeof globalValue !== 'undefined') {
              const resolved = resolveInputValue(input.id, connections, anchorValueMap, anchorFromId) ?? globalValue;
              if (resolved !== anchorValueMap.get(input.id)) {
                anchorValueMap.set(input.id, resolved);
                changed = true;
              }
            }
          }
          continue;
        }
        const definition = blockCatalog[block.type];
        if (!definition) continue;

        const inputValues: unknown[] = [];
        for (const anchor of block.inputs) {
          inputValues.push(resolveInputValue(anchor.id, connections, anchorValueMap, anchorFromId));
        }

        const currentOutputs: unknown[] = block.outputs.map((a) => anchorValueMap.get(a.id));
        const evaluated = definition.evaluate(inputValues, currentOutputs);
        for (let outputIndex = 0; outputIndex < block.outputs.length; outputIndex += 1) {
          const anchor = block.outputs[outputIndex];
          const nextValue = evaluated[outputIndex];
          const currentValue = anchorValueMap.get(anchor.id);
          if (nextValue !== currentValue) {
            anchorValueMap.set(anchor.id, nextValue);
            changed = true;
          }
        }
      }
    }
  } while (changed && cycle < iterationLimit);

  return anchorValueMap;
};

type IoDialogState = {
  open: boolean;
  type: 'INPUT' | 'OUTPUT';
  networkIndex: number;
};

type SnackbarState = {
  open: boolean;
  message: string;
  severity: 'info' | 'success' | 'warning' | 'error';
};

type ValidationCase = { set: Record<string, unknown>; expect: boolean };
type ValidationResult = { inputs: Record<string, unknown>; expected: boolean; actual: boolean };

const anchorBaseStyle: React.CSSProperties = {
  width: 18,
  height: 18,
  borderRadius: '50%',
  display: 'inline-block',
  cursor: 'pointer'
};

const M10_U2_X1_FupUebung: React.FC = () => {
  const { darkMode } = useTheme();
  const anchorColor = darkMode ? tokens.colors.dark.custom1 : tokens.colors.light.custom1;
  const { totalScore, token, canViewM10Fup, canEditM10FupAccess, canUseM10FupSimulation, canEditM10FupBlocks, canEditM10FupNetworks, canSaveM10FupProjects, canValidateM10FupTasks } = useAuth();
  const { override, refresh } = useUnitOverride(PAGE_ID);
  const [networks, setNetworks] = React.useState<FupNetwork[]>([
    createNetwork(0),
    createNetwork(1)
  ]);
  const [connections, setConnections] = React.useState<Connection[]>([]);
  const [selectedTaskIndex, setSelectedTaskIndex] = React.useState(0);
  const [taskDialogOpen, setTaskDialogOpen] = React.useState(false);
  const [variableDialogOpen, setVariableDialogOpen] = React.useState(false);
  const [ioDialog, setIoDialog] = React.useState<IoDialogState | null>(null);
  const [ioName, setIoName] = React.useState('');
  const [ioType, setIoType] = React.useState<DataType>('BOOL');
  const [ioValue, setIoValue] = React.useState('FALSE');
  const [selectedFunction, setSelectedFunction] = React.useState<string>('AND');
  const [pendingAnchorId, setPendingAnchorId] = React.useState<string | null>(null);
  const [isSimulating, setIsSimulating] = React.useState(false);
  const [snackbar, setSnackbar] = React.useState<SnackbarState>({
    open: false,
    message: '',
    severity: 'info'
  });
  const [validationOpen, setValidationOpen] = React.useState(false);
  const [validationResults, setValidationResults] = React.useState<ValidationResult[] | null>(null);
  const [globalValues, setGlobalValues] = React.useState<Map<string, unknown>>(new Map());
  const [infoOpen, setInfoOpen] = React.useState(false);
  const paperRef = React.useRef<HTMLDivElement | null>(null);
  const anchorRefs = React.useRef<Map<string, HTMLDivElement>>(new Map());
  const animationFrameId = React.useRef<number | null>(null);
  const rawRequired = Number(override?.design?.requiredLevel);
  const currentRequired = Number.isFinite(rawRequired) && rawRequired >= 0 ? rawRequired : 1000;

  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [requiredLevel, setRequiredLevel] = React.useState<string>(String(currentRequired));
  const [submitting, setSubmitting] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);
  const [success, setSuccess] = React.useState<string | null>(null);

  const [linePositions, setLinePositions] = React.useState<Record<string, { x1: number; y1: number; x2: number; y2: number }>>({});

  const addInput = (blockId: string) => {
    if (isSimulating) {
      showSnackbar('Bearbeitung während der Simulation gesperrt.', 'warning');
      return;
    }
    if (!canEditM10FupBlocks) {
      showSnackbar('Keine Berechtigung zum Bearbeiten von Blöcken.', 'warning');
      return;
    }
    setNetworks((prev) =>
      prev.map((network) => ({
        ...network,
        blocks: network.blocks.map((b) => {
          if (b.id !== blockId) return b;
          if (!EXPANDABLE_TYPES.has(b.type)) return b;
          const nextIndex = b.inputs.length + 1;
          const newAnchor: Anchor = {
            id: createId(),
            blockId: b.id,
            isInput: true,
            name: `IN${nextIndex}`,
            dataType: 'BOOL',
            value: false
          };
          return { ...b, inputs: [...b.inputs, newAnchor] };
        })
      }))
    );
  };

  const removeInput = (blockId: string) => {
    if (isSimulating) {
      showSnackbar('Bearbeitung während der Simulation gesperrt.', 'warning');
      return;
    }
    if (!canEditM10FupBlocks) {
      showSnackbar('Keine Berechtigung zum Bearbeiten von Blöcken.', 'warning');
      return;
    }
    setNetworks((prev) =>
      prev.map((network) => ({
        ...network,
        blocks: network.blocks.map((b) => {
          if (b.id !== blockId) return b;
          if (!EXPANDABLE_TYPES.has(b.type)) return b;
          const minInputs = 2; // Für diese Standardblöcke mindestens 2 Eingänge
          if (b.inputs.length <= minInputs) return b;
          const removed = b.inputs[b.inputs.length - 1];
          // eingehende Verbindung zum entfernten Eingang auch löschen
          setConnections((prevConn) => prevConn.filter((c) => c.toAnchorId !== removed.id));
          return { ...b, inputs: b.inputs.slice(0, -1) };
        })
      }))
    );
  };

  const updateLinePositions = React.useCallback(() => {
    const container = paperRef.current;
    if (!container) return;
    const containerRect = container.getBoundingClientRect();
    const positions: Record<string, { x1: number; y1: number; x2: number; y2: number }> = {};

    connections.forEach((connection) => {
      const fromEl = anchorRefs.current.get(connection.fromAnchorId);
      const toEl = anchorRefs.current.get(connection.toAnchorId);
      if (!fromEl || !toEl) return;
      const fromRect = fromEl.getBoundingClientRect();
      const toRect = toEl.getBoundingClientRect();
      const x1 = fromRect.left + fromRect.width / 2 - containerRect.left;
      const y1 = fromRect.top + fromRect.height / 2 - containerRect.top;
      const x2 = toRect.left + toRect.width / 2 - containerRect.left;
      const y2 = toRect.top + toRect.height / 2 - containerRect.top;
      positions[connection.id] = { x1, y1, x2, y2 };
    });

    setLinePositions((prev) => {
      const prevKeys = Object.keys(prev);
      const nextKeys = Object.keys(positions);
      if (prevKeys.length === nextKeys.length) {
        let identical = true;
        for (const key of nextKeys) {
          const prevPos = prev[key];
          const nextPos = positions[key];
          if (!prevPos || !nextPos) {
            identical = false;
            break;
          }
          if (
            prevPos.x1 !== nextPos.x1 ||
            prevPos.y1 !== nextPos.y1 ||
            prevPos.x2 !== nextPos.x2 ||
            prevPos.y2 !== nextPos.y2
          ) {
            identical = false;
            break;
          }
        }
        if (identical) {
          return prev;
        }
      }
      return positions;
    });
  }, [connections]);

  const scheduleLineUpdate = React.useCallback(() => {
    if (animationFrameId.current) {
      window.cancelAnimationFrame(animationFrameId.current);
    }
    animationFrameId.current = window.requestAnimationFrame(() => {
      animationFrameId.current = null;
      updateLinePositions();
    });
  }, [updateLinePositions]);

  React.useLayoutEffect(() => {
    scheduleLineUpdate();
  }, [connections, networks, scheduleLineUpdate]);

  React.useEffect(() => {
    const handleResize = () => scheduleLineUpdate();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [scheduleLineUpdate]);

  React.useEffect(() => () => {
    if (animationFrameId.current) {
      window.cancelAnimationFrame(animationFrameId.current);
    }
  }, []);

  React.useEffect(() => {
    if (!isSimulating) return;

    const runCycle = () => {
      setNetworks((prev) => {
        const clone = prev.map((network) => ({
          ...network,
          blocks: network.blocks.map((block) => ({
            ...block,
            inputs: block.inputs.map((anchor) => ({ ...anchor })),
            outputs: block.outputs.map((anchor) => ({ ...anchor }))
          }))
        }));

        const values = evaluateNetworks(clone, connections, globalValues);

        clone.forEach((network) => {
          network.blocks.forEach((block) => {
            block.outputs.forEach((anchor) => {
              if (values.has(anchor.id)) {
                anchor.value = values.get(anchor.id);
              }
            });
            if (block.type === 'OUTPUT') {
              block.inputs.forEach((anchor) => {
                const mapped = resolveInputValue(anchor.id, connections, values, (id: string) => {
                  for (const net of clone) {
                    for (const blk of net.blocks) {
                      const a = [...blk.inputs, ...blk.outputs].find((item) => item.id === id);
                      if (a) return a;
                    }
                  }
                  return undefined;
                });
                if (typeof mapped !== 'undefined') {
                  anchor.value = mapped;
                }
              });
            }
          });
        });

        return clone;
      });
    };

    const handle = window.setInterval(runCycle, 120);
    runCycle();
    return () => window.clearInterval(handle);
  }, [isSimulating, connections, globalValues]);

  const showSnackbar = React.useCallback((message: string, severity: SnackbarState['severity'] = 'info') => {
    setSnackbar({ open: true, message, severity });
  }, []);

  const handleSnackbarClose = () => setSnackbar((prev) => ({ ...prev, open: false }));

  const resetCanvas = React.useCallback(() => {
    setIsSimulating(false);
    setPendingAnchorId(null);
    setConnections([]);
    setNetworks([createNetwork(0), createNetwork(1)]);
    setGlobalValues(new Map());
  }, []);

  const handleOpenTasks = () => {
    setTaskDialogOpen(true);
  };

  const handleCloseTasks = () => setTaskDialogOpen(false);

  const handlePrevTask = () => {
    setSelectedTaskIndex((prev) => {
      const next = Math.max(prev - 1, 0);
      resetCanvas();
      return next;
    });
  };

  const handleNextTask = () => {
    setSelectedTaskIndex((prev) => {
      const next = Math.min(prev + 1, taskList.length - 1);
      resetCanvas();
      return next;
    });
  };

  const handleVariablesDialog = () => {
    setVariableDialogOpen(true);
  };

  const closeVariablesDialog = () => setVariableDialogOpen(false);

  const handleAddNetwork = () => {
    if (isSimulating) {
      showSnackbar('Bearbeitung während der Simulation gesperrt.', 'warning');
      return;
    }
    if (!canEditM10FupNetworks) {
      showSnackbar('Keine Berechtigung zum Verwalten von Netzwerken.', 'warning');
      return;
    }
    setNetworks((prev) => [...prev, createNetwork(prev.length)]);
    showSnackbar('Neues Netzwerk hinzugefügt', 'success');
  };

  const handleQuickAddFunction = (networkIndex: number) => {
    if (isSimulating) {
      showSnackbar('Bearbeitung während der Simulation gesperrt.', 'warning');
      return;
    }
    if (!canEditM10FupBlocks) {
      showSnackbar('Keine Berechtigung zum Hinzufuegen von Bloecken.', 'warning');
      return;
    }
    const type = selectedFunction;
    if (!blockCatalog[type]) {
      showSnackbar('Dieser Funktionsbaustein ist noch nicht verfügbar.', 'warning');
      return;
    }
    setNetworks((prev) => prev.map((network, index) => (
      index === networkIndex
        ? { ...network, blocks: [...network.blocks, createBlock(type)] }
        : network
    )));
    showSnackbar(`${type} hinzugefügt`, 'success');
  };

  const handleDragStart = (event: React.DragEvent, type: string) => {
    event.dataTransfer.setData('text/plain', type);
    event.dataTransfer.effectAllowed = 'copy';
  };

  const handleDrop = (event: React.DragEvent, networkIndex: number) => {
    event.preventDefault();
    if (isSimulating) {
      showSnackbar('Bearbeitung während der Simulation gesperrt.', 'warning');
      return;
    }
    if (!canEditM10FupBlocks) {
      showSnackbar('Keine Berechtigung zum Hinzufuegen von Bloecken.', 'warning');
      return;
    }
    const type = event.dataTransfer.getData('text/plain');
    if (!type) return;

    if (type === 'INPUT' || type === 'OUTPUT') {
      setIoDialog({ open: true, type, networkIndex });
      setIoName(type === 'INPUT' ? 'I1' : 'Q1');
      setIoType('BOOL');
      setIoValue(type === 'INPUT' ? 'FALSE' : 'FALSE');
      return;
    }

    if (!blockCatalog[type]) {
      showSnackbar('Dieser Funktionsbaustein ist noch nicht verfügbar.', 'warning');
      return;
    }

    setNetworks((prev) => {
      const clone = prev.map((network, index) =>
        index === networkIndex
          ? { ...network, blocks: [...network.blocks, createBlock(type)] }
          : network
      );
      return clone;
    });
    showSnackbar(`${type} hinzugefügt`, 'success');
  };

  const handleQuickAddIo = (networkIndex: number, type: 'INPUT' | 'OUTPUT') => {
    if (isSimulating) {
      showSnackbar('Bearbeitung während der Simulation gesperrt.', 'warning');
      return;
    }
    if (!canEditM10FupBlocks) {
      showSnackbar('Keine Berechtigung zum Hinzufuegen von Ein-/Ausgaengen.', 'warning');
      return;
    }
    setIoDialog({ open: true, type, networkIndex });
    setIoName(type === 'INPUT' ? 'I1' : 'Q1');
    setIoType('BOOL');
    setIoValue('FALSE');
  };

  const handleDragOver = (event: React.DragEvent) => {
    event.preventDefault();
  };

  const handleIoDialogClose = () => setIoDialog(null);

  const convertInitialValue = (raw: string, type: DataType) => {
    switch (type) {
      case 'BOOL':
        return raw.toLowerCase() === 'true';
      case 'INT':
        return Number.parseInt(raw, 10) || 0;
      case 'REAL':
        return Number.parseFloat(raw) || 0;
      case 'STRING':
        return raw;
      case 'TIME':
        return raw || 'T#0s';
      default:
        return raw;
    }
  };

  const handleIoDialogSubmit = () => {
    if (!ioDialog) return;
    const { networkIndex, type } = ioDialog;
    const initialValue = convertInitialValue(ioValue, ioType);

    const block: FupBlock = {
      id: createId(),
      type,
      inputs: type === 'OUTPUT'
        ? [createAnchor('', true, ioName || 'Q?', ioType, initialValue)]
        : [],
      outputs: type === 'INPUT'
        ? [createAnchor('', false, ioName || 'I?', ioType, initialValue)]
        : []
    };
    block.inputs.forEach((anchor) => (anchor.blockId = block.id));
    block.outputs.forEach((anchor) => (anchor.blockId = block.id));

    setNetworks((prev) => prev.map((network, index) => {
      if (index !== networkIndex) return network;
      return { ...network, blocks: [...network.blocks, block] };
    }));
    setIoDialog(null);
    showSnackbar(`${type === 'INPUT' ? 'Eingang' : 'Ausgang'} hinzugefügt`, 'success');
  };

  const anchorFromId = React.useCallback(
    (id: string): Anchor | undefined => {
      for (const network of networks) {
        for (const block of network.blocks) {
          const anchor = [...block.inputs, ...block.outputs].find((item) => item.id === id);
          if (anchor) return anchor;
        }
      }
      return undefined;
    },
    [networks]
  );

  const handleAnchorClick = (anchor: Anchor, block: FupBlock) => {
    if (isSimulating && block.type === 'INPUT' && !anchor.isInput) {
      // BOOL-Werte: Toggle
      if (anchor.dataType === 'BOOL') {
        const newValue = !Boolean(anchor.value);
        if (anchor.name) {
          setGlobalValues((prev) => {
            const next = new Map(prev);
            next.set(anchor.name, newValue);
            return next;
          });
        }
        setNetworks((prev) =>
          prev.map((network) => ({
            ...network,
            blocks: network.blocks.map((candidate) => {
              if (candidate.id !== block.id) return candidate;
              return {
                ...candidate,
                outputs: candidate.outputs.map((output) =>
                  output.id === anchor.id
                    ? { ...output, value: newValue }
                    : output
                )
              };
            })
          }))
        );
        return;
      }
      
      // REAL/INT-Werte: Dialog zum Eingeben
      if (anchor.dataType === 'REAL' || anchor.dataType === 'INT') {
        const newValue = prompt(`Neuer Wert für ${anchor.name} (${anchor.dataType}):`, String(anchor.value));
        if (newValue === null) return;
        
        const convertedValue = anchor.dataType === 'REAL' 
          ? Number.parseFloat(newValue) || 0 
          : Number.parseInt(newValue, 10) || 0;
        
        if (anchor.name) {
          setGlobalValues((prev) => {
            const next = new Map(prev);
            next.set(anchor.name, convertedValue);
            return next;
          });
        }
        setNetworks((prev) =>
          prev.map((network) => ({
            ...network,
            blocks: network.blocks.map((candidate) => {
              if (candidate.id !== block.id) return candidate;
              return {
                ...candidate,
                outputs: candidate.outputs.map((output) =>
                  output.id === anchor.id
                    ? { ...output, value: convertedValue }
                    : output
                )
              };
            })
          }))
        );
        return;
      }
    }

    if (isSimulating) {
      showSnackbar('Verbindungen sind im Simulationsmodus gesperrt.', 'warning');
      return;
    }

    if (!canEditM10FupBlocks) {
      showSnackbar('Keine Berechtigung zum Erstellen von Verbindungen.', 'warning');
      return;
    }

    if (!pendingAnchorId) {
      if (anchor.isInput) {
        showSnackbar('Bitte zuerst einen Ausgang wählen.', 'info');
        return;
      }
      setPendingAnchorId(anchor.id);
      return;
    }

    if (pendingAnchorId === anchor.id) {
      setPendingAnchorId(null);
      return;
    }

    if (!anchor.isInput) {
      showSnackbar('Bitte einen Eingang als Ziel wählen.', 'info');
      return;
    }

    const startAnchor = anchorFromId(pendingAnchorId);
    if (!startAnchor) {
      setPendingAnchorId(null);
      return;
    }

    if (startAnchor.blockId === anchor.blockId) {
      showSnackbar('Ein Block darf nicht mit sich selbst verbunden werden.', 'warning');
      setPendingAnchorId(null);
      return;
    }

    if (startAnchor.dataType !== anchor.dataType) {
      showSnackbar('Unterschiedliche Datentypen können nicht verbunden werden.', 'warning');
      setPendingAnchorId(null);
      return;
    }

    const duplicatePair = connections.find(
      (connection) => connection.toAnchorId === anchor.id && connection.fromAnchorId === startAnchor.id
    );
    if (duplicatePair) {
      showSnackbar('Diese Verbindung existiert bereits.', 'warning');
      setPendingAnchorId(null);
      return;
    }

    // Eingänge weiterhin single-source (klar definierte Treiber)
    const inputAlreadyConnected = connections.some((c) => c.toAnchorId === anchor.id);
    if (inputAlreadyConnected) {
      showSnackbar('Dieser Eingang ist bereits belegt.', 'warning');
      setPendingAnchorId(null);
      return;
    }

    setConnections((prev) => [...prev, { id: createId(), fromAnchorId: startAnchor.id, toAnchorId: anchor.id }]);
    setPendingAnchorId(null);
  };

  const handleDeleteBlock = (blockId: string) => {
    if (isSimulating) {
      showSnackbar('Bearbeitung während der Simulation gesperrt.', 'warning');
      return;
    }
    if (!canEditM10FupBlocks) {
      showSnackbar('Keine Berechtigung zum Loeschen von Bloecken.', 'warning');
      return;
    }
    setConnections((prev) =>
      prev.filter((connection) => {
        const fromAnchor = anchorFromId(connection.fromAnchorId);
        const toAnchor = anchorFromId(connection.toAnchorId);
        return fromAnchor?.blockId === blockId || toAnchor?.blockId === blockId ? false : true;
      })
    );
    setNetworks((prev) => prev.map((network) => ({
      ...network,
      blocks: network.blocks.filter((block) => block.id !== blockId)
    })));
    if (pendingAnchorId) {
      const pendingAnchor = anchorFromId(pendingAnchorId);
      if (pendingAnchor?.blockId === blockId) {
        setPendingAnchorId(null);
      }
    }
  };

  const handleSimulateToggle = () => {
    if (!canUseM10FupSimulation) {
      showSnackbar('Keine Berechtigung fuer die Simulation.', 'warning');
      return;
    }
    if (connections.length === 0) {
      showSnackbar('Keine Verbindungen vorhanden.', 'warning');
      return;
    }
    setIsSimulating((prev) => !prev);
  };

  const fileInputRef = React.useRef<HTMLInputElement | null>(null);

  const handleSave = () => {
    if (!canSaveM10FupProjects) {
      showSnackbar('Keine Berechtigung zum Speichern von Projekten.', 'warning');
      return;
    }
    const data = {
      version: 1,
      selectedTaskIndex,
      networks,
      connections,
    };
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `fup_project_${new Date().toISOString().replace(/[:.]/g, '-')}.json`;
    a.click();
    URL.revokeObjectURL(url);
    showSnackbar('Projekt gespeichert (Download gestartet).', 'success');
  };

  const handleLoadClick = () => {
    if (!canSaveM10FupProjects) {
      showSnackbar('Keine Berechtigung zum Laden von Projekten.', 'warning');
      return;
    }
    fileInputRef.current?.click();
  };

  const handleLoadFile: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const data = JSON.parse(String(reader.result || '{}'));
        if (!data || !Array.isArray(data.networks) || !Array.isArray(data.connections)) {
          showSnackbar('Ungültige Datei.', 'error');
          return;
        }
        setIsSimulating(false);
        setPendingAnchorId(null);
        setSelectedTaskIndex(Number(data.selectedTaskIndex) || 0);
        setNetworks(data.networks);
        setConnections(data.connections);
        setGlobalValues(new Map());
        showSnackbar('Projekt geladen.', 'success');
      } catch (err) {
        showSnackbar('Konnte Datei nicht lesen.', 'error');
      }
    };
    reader.readAsText(file);
    e.target.value = '';
  };

  const getTaskTestCases = (taskIndex: number): ValidationCase[] => {
    switch (taskIndex) {
      case 0: return [
        { set: { I1: false, I2: false }, expect: false },
        { set: { I1: true, I2: false }, expect: false },
        { set: { I1: false, I2: true }, expect: false },
        { set: { I1: true, I2: true }, expect: true }
      ];
      case 1: return [
        { set: { I1: false, I2: false }, expect: false },
        { set: { I1: true, I2: false }, expect: true },
        { set: { I1: false, I2: true }, expect: true },
        { set: { I1: true, I2: true }, expect: false }
      ];
      case 2: return [
        { set: { I1: true, I2: false, I3: false }, expect: true },
        { set: { I1: true, I2: true, I3: false }, expect: false },
        { set: { I1: false, I2: false, I3: false }, expect: false }
      ];
      case 3: return [
        { set: { I1: false, I2: false }, expect: false },
        { set: { I1: true, I2: false }, expect: true },
        { set: { I1: false, I2: true }, expect: true }
      ];
      case 4: return [
        { set: { I1: true, I2: false }, expect: true },
        { set: { I1: true, I2: true }, expect: false }
      ];
      case 5: return [
        { set: { I1: true, I2: true }, expect: true },
        { set: { I1: true, I2: false }, expect: false }
      ];
      case 6: return [
        { set: { I1: true, I2: false, I3: false }, expect: true },
        { set: { I1: false, I2: true, I3: false }, expect: true },
        { set: { I1: true, I2: true, I3: true }, expect: false }
      ];
      case 7: return [
        { set: { I1: true, I2: true, I3: true }, expect: true },
        { set: { I1: true, I2: true, I3: false }, expect: false }
      ];
      case 8: return [
        { set: { I1: true, I2: false, I3: true, I4: false }, expect: true },
        { set: { I1: false, I2: true, I3: false, I4: true }, expect: true },
        { set: { I1: true, I2: true, I3: false, I4: false }, expect: false }
      ];
      case 9: return [
        { set: { I1: false, I2: false, I3: false }, expect: false },
        { set: { I1: true, I2: false, I3: false }, expect: true },
        { set: { I1: false, I2: true, I3: true }, expect: false }
      ];
      case 10: return [
        { set: { I1: 5, I2: 7 }, expect: false },
        { set: { I1: 7.1, I2: 7 }, expect: true },
        { set: { I1: 7, I2: 7 }, expect: false }
      ];
      case 11: return [
        { set: { I1: true, I2: true, I3: false }, expect: true },
        { set: { I1: true, I2: false, I3: true }, expect: true },
        { set: { I1: false, I2: true, I3: true }, expect: true },
        { set: { I1: true, I2: false, I3: false }, expect: false }
      ];
      case 12: return [
        { set: { I1: false, I2: false }, expect: true },
        { set: { I1: true, I2: true }, expect: true },
        { set: { I1: true, I2: false }, expect: false }
      ];
      case 13: return [
        { set: { I1: false, I2: true, I3: false }, expect: true },
        { set: { I1: true, I2: false, I3: true }, expect: true },
        { set: { I1: true, I2: true, I3: false }, expect: false }
      ];
      case 14: return [
        { set: { I1: true, I2: false, I3: false, I4: false }, expect: true },
        { set: { I1: true, I2: true, I3: false, I4: false }, expect: false }
      ];
      case 15: return [
        { set: { I1: 15, I2: 10, I3: 20 }, expect: true },
        { set: { I1: 9.9, I2: 10, I3: 20 }, expect: false },
        { set: { I1: 20.1, I2: 10, I3: 20 }, expect: false }
      ];
      case 16: return [
        { set: { I1: true, I2: true, I3: true, I4: false }, expect: true },
        { set: { I1: true, I2: true, I3: false, I4: true }, expect: true },
        { set: { I1: true, I2: false, I3: true, I4: false }, expect: false }
      ];
      case 17: return [
        { set: { I1: false, I2: false, I3: false, I4: false }, expect: false },
        { set: { I1: true, I2: false, I3: false, I4: false }, expect: true },
        { set: { I1: true, I2: true, I3: false, I4: false }, expect: false },
        { set: { I1: true, I2: true, I3: true, I4: false }, expect: true }
      ];
      case 18: return [
        { set: { I1: false, I2: false, I3: false, I4: false }, expect: false },
        { set: { I1: true, I2: false, I3: false, I4: false }, expect: true },
        { set: { I1: false, I2: true, I3: true, I4: true }, expect: false }
      ];
      case 19: return [
        { set: { I1: true, I2: false, I3: false, I4: false }, expect: true },
        { set: { I1: false, I2: true, I3: true, I4: false }, expect: true },
        { set: { I1: false, I2: true, I3: false, I4: false }, expect: false },
        { set: { I1: false, I2: true, I3: true, I4: true }, expect: false }
      ];
      default: return [];
    }
  };

  const handleValidateTask = () => {
    if (!canValidateM10FupTasks) {
      showSnackbar('Keine Berechtigung zum Pruefen von Aufgaben.', 'warning');
      return;
    }
    if (!isSimulating) {
      showSnackbar('Bitte starte zuerst die Simulation (Play-Button).', 'info');
      return;
    }
    const cases = getTaskTestCases(selectedTaskIndex);
    if (cases.length === 0) {
      showSnackbar('Keine Prüflogik für diese Aufgabe vorhanden.', 'info');
      return;
    }
    
    // Automatische Validierung durchführen
    const results: ValidationResult[] = cases.map(testCase => {
      // Inputs setzen - Erstelle temporäre Map mit Test-Werten
      const testGlobalValues = new Map<string, unknown>();
      
      // Zuerst alle existierenden globalen Werte kopieren
      for (const network of networks) {
        for (const block of network.blocks) {
          if (block.type === 'INPUT' || block.type === 'OUTPUT') {
            const anchor = block.type === 'INPUT' ? block.outputs[0] : block.inputs[0];
            if (anchor?.name) {
              // Setze Defaultwert basierend auf Datentyp
              testGlobalValues.set(anchor.name, anchor.dataType === 'BOOL' ? false : 0);
            }
          }
        }
      }
      
      // Dann Test-Werte überschreiben
      Object.entries(testCase.set).forEach(([key, value]) => {
        testGlobalValues.set(key, value);
      });
      
      // Netzwerk evaluieren mit Test-Werten (ohne globalValues zu verändern)
      const anchorValueMap = evaluateNetworks(networks, connections, new Map(testGlobalValues));
      
      // OUTPUT-Wert auslesen (Q1 oder Q?)
      let actualValue: unknown = false;
      let found = false;
      for (const network of networks) {
        for (const block of network.blocks) {
          if (block.type === 'OUTPUT') {
            const inputAnchor = block.inputs[0];
            if (inputAnchor?.name === 'Q1' || inputAnchor?.name?.startsWith('Q')) {
              // Der Wert kommt von der evaluierten Verbindung
              actualValue = anchorValueMap.get(inputAnchor.id);
              found = true;
              break;
            }
          }
        }
        if (found) break;
      }
      
      return {
        inputs: testCase.set,
        expected: Boolean(testCase.expect),
        actual: Boolean(actualValue)
      };
    });
    
    setValidationResults(results);
    setValidationOpen(true);
  };

  const handleAnchorDoubleClick = (anchor: Anchor) => {
    if (anchor.dataType !== 'BOOL') return;
    setNetworks((prev) =>
      prev.map((network) => ({
        ...network,
        blocks: network.blocks.map((b) => ({
          ...b,
          inputs: b.inputs.map((a) => (a.id === anchor.id ? { ...a, negated: !a.negated } : a)),
          outputs: b.outputs.map((a) => (a.id === anchor.id ? { ...a, negated: !a.negated } : a))
        }))
      }))
    );
    showSnackbar(`Negation ${anchor.negated ? 'entfernt' : 'hinzugefügt'}`, 'info');
  };

  const renderAnchor = (anchor: Anchor, block: FupBlock) => {
    const selected = pendingAnchorId === anchor.id;
    const handleRef = (element: HTMLDivElement | null) => {
      if (!element) {
        anchorRefs.current.delete(anchor.id);
      } else {
        anchorRefs.current.set(anchor.id, element);
      }
      scheduleLineUpdate();
    };
    return (
      <Box
        key={anchor.id}
        sx={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}
      >
        <Box
          ref={handleRef}
          onClick={() => handleAnchorClick(anchor, block)}
          onDoubleClick={() => handleAnchorDoubleClick(anchor)}
          sx={{
            ...anchorBaseStyle,
            backgroundColor: selected ? tokens.colors.primary : anchorColor,
            border: selected ? `2px solid ${tokens.colors.primary}` : 'none',
            marginLeft: anchor.isInput ? 0 : 1,
            marginRight: anchor.isInput ? 1 : 0
          }}
        />
        {anchor.negated && anchor.dataType === 'BOOL' && (
          <Box
            sx={{
              position: 'absolute',
              left: anchor.isInput ? -6 : 'auto',
              right: anchor.isInput ? 'auto' : -6,
              top: '50%',
              transform: 'translateY(-50%)',
              width: 10,
              height: 10,
              borderRadius: '50%',
              border: `2px solid ${tokens.colors.primary}`,
              backgroundColor: darkMode ? tokens.colors.dark.surface : tokens.colors.light.surface,
              pointerEvents: 'none'
            }}
          />
        )}
      </Box>
    );
  };

  const renderBlock = (block: FupBlock, networkIndex: number) => {
    if (block.type === 'INPUT') {
      const output = block.outputs[0];
      return (
        <Paper key={block.id} sx={{ ...getCardSx(darkMode), p: 1.5, position: 'relative', width: 160 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600, color: darkMode ? tokens.colors.dark.text : tokens.colors.light.custom1 }}>
            {output?.name || 'INPUT'}
          </Typography>
          <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>
            {String(output?.value).toUpperCase()}
          </Typography>
          <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mt: 1 }}>
            <Typography variant="caption" sx={{ color: darkMode ? tokens.colors.dark.textSecondary : tokens.colors.light.textSecondary }}>
              {output?.dataType}
            </Typography>
            <Stack direction="row" spacing={1} alignItems="center">
              {output && (
                <Tooltip title={`${output.name}: ${output.dataType} Ausgang (${output.name}) – liefert ${output.dataType}`} placement="right" arrow>
                  <span>{renderAnchor(output, block)}</span>
                </Tooltip>
              )}
              <IconButton size="small" onClick={() => handleDeleteBlock(block.id)}>
                <DeleteOutlineIcon fontSize="small" />
              </IconButton>
            </Stack>
          </Stack>
        </Paper>
      );
    }

    if (block.type === 'OUTPUT') {
      const input = block.inputs[0];
      return (
        <Paper key={block.id} sx={{ ...getCardSx(darkMode), p: 1.5, position: 'relative', width: 160 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600, color: darkMode ? tokens.colors.dark.text : tokens.colors.light.custom1 }}>
            {input?.name || 'OUTPUT'}
          </Typography>
          <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>
            {String(input?.value).toUpperCase()}
          </Typography>
          <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mt: 1 }}>
            <Stack direction="row" spacing={1} alignItems="center">
              {input && (
                <Tooltip title={`${input.name}: ${input.dataType} Eingang (${input.name}) – erwartet ${input.dataType}`} placement="left" arrow>
                  <span>{renderAnchor(input, block)}</span>
                </Tooltip>
              )}
            </Stack>
            <IconButton size="small" onClick={() => handleDeleteBlock(block.id)}>
              <DeleteOutlineIcon fontSize="small" />
            </IconButton>
          </Stack>
        </Paper>
      );
    }

    const definition = blockCatalog[block.type];
    const SvgComponent = definition?.svgComponent;
    // Dynamische Blockbreite basierend auf Anzahl der Eingänge/Ausgänge
    const blockWidth = block.type === 'INPUT' || block.type === 'OUTPUT' ? 160 : Math.max(200, 140 + Math.max(block.inputs.length, block.outputs.length) * 8);
    return (
      <Paper key={block.id} sx={{ ...getCardSx(darkMode), p: 1.5, position: 'relative', width: blockWidth }}>
        <Stack direction="row" spacing={1} alignItems="center">
          {SvgComponent ? (
            <Box sx={{ width: 50, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <SvgComponent width={50} height={40} />
            </Box>
          ) : (
            <Box component="img" src={definition?.icon ?? '/assets/drawable/zzz_help.png'} alt={block.type} sx={{ width: 36, height: 36, borderRadius: 1 }} />
          )}
          <Typography variant="subtitle2" sx={{ fontWeight: 600, color: darkMode ? tokens.colors.dark.text : tokens.colors.light.custom1 }}>
            {block.type}
          </Typography>
          <Box sx={{ flexGrow: 1 }} />
          {EXPANDABLE_TYPES.has(block.type) && (
            <Stack direction="row" spacing={0.5} alignItems="center" sx={{ mr: 0.5 }}>
              <IconButton size="small" onClick={() => addInput(block.id)} title="Eingang hinzufügen">
                <AddIcon fontSize="small" />
              </IconButton>
              <IconButton size="small" onClick={() => removeInput(block.id)} title="Eingang entfernen">
                <RemoveIcon fontSize="small" />
              </IconButton>
            </Stack>
          )}
          <IconButton size="small" onClick={() => handleDeleteBlock(block.id)}>
            <DeleteOutlineIcon fontSize="small" />
          </IconButton>
          <Tooltip title={`${block.type}: ${block.inputs.length} Eingänge, ${block.outputs.length} Ausgänge`} placement="top" arrow>
            <HelpOutlineIcon fontSize="small" sx={{ cursor: 'help', color: darkMode ? tokens.colors.dark.textSecondary : tokens.colors.light.textSecondary }} />
          </Tooltip>
        </Stack>
        <Stack direction="row" justifyContent="space-between" sx={{ mt: 1.5 }}>
          <Stack spacing={1} alignItems="flex-start">
            {block.inputs.map((anchor) => {
              const def = blockCatalog[block.type];
              const meta = def?.inputs.find((i) => i.name === anchor.name);
              const desc = meta?.description ?? `Eingang (${anchor.name}) – erwartet ${anchor.dataType}`;
              const title = `${anchor.name}: ${anchor.dataType} ${desc}`;
              return (
                <Stack key={anchor.id} direction="row" spacing={1} alignItems="center">
                  <Tooltip title={title} placement="left" arrow>
                    <span>{renderAnchor(anchor, block)}</span>
                  </Tooltip>
                  <Typography variant="caption" sx={{ color: darkMode ? tokens.colors.dark.textSecondary : tokens.colors.light.textSecondary }}>{anchor.name}: {anchor.dataType}</Typography>
                </Stack>
              );
            })}
          </Stack>
          <Stack spacing={1} alignItems="flex-end">
            {block.outputs.map((anchor) => {
              const def = blockCatalog[block.type];
              const meta = def?.outputs.find((o) => o.name === anchor.name);
              const desc = meta?.description ?? `Ausgang (${anchor.name}) – liefert ${anchor.dataType}`;
              const title = `${anchor.name}: ${anchor.dataType} ${desc}`;
              return (
                <Stack key={anchor.id} direction="row" spacing={1} alignItems="center">
                  <Typography variant="caption" sx={{ color: darkMode ? tokens.colors.dark.textSecondary : tokens.colors.light.textSecondary }}>{anchor.name}: {anchor.dataType}</Typography>
                  <Tooltip title={title} placement="right" arrow>
                    <span>{renderAnchor(anchor, block)}</span>
                  </Tooltip>
                </Stack>
              );
            })}
          </Stack>
        </Stack>
      </Paper>
    );
  };

  const renderNetwork = (network: FupNetwork, networkIndex: number) => {
    const layout = computeNetworkLayout(network, connections);
    const minWidth = Math.max(900, (network.blocks.filter(b => b.type !== 'INPUT' && b.type !== 'OUTPUT').length + 1) * 260 + 250);
    return (
    <Paper
      key={network.id}
      sx={{
        ...getCardSx(darkMode),
        p: 2,
        mb: 3,
        minHeight: layout.height + 40,
        minWidth: minWidth,
        overflowX: 'auto',
        overflowY: 'visible'
      }}
      onDrop={(event) => handleDrop(event, networkIndex)}
      onDragOver={handleDragOver}
    >
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: tokens.colors.primary }}>
          {network.title}
        </Typography>
        <Button size="small" startIcon={<AddIcon />} onClick={() => handleQuickAddIo(networkIndex, 'INPUT')} disabled={isSimulating}>
          Eingang
        </Button>
        <Button size="small" startIcon={<AddIcon />} onClick={() => handleQuickAddIo(networkIndex, 'OUTPUT')} disabled={isSimulating}>
          Ausgang
        </Button>
        <Button size="small" startIcon={<AddIcon />} onClick={() => handleQuickAddFunction(networkIndex)} disabled={isSimulating}>
          Funktion
        </Button>
      </Stack>
      <Divider sx={{ mb: 2 }} />
      <Box sx={{ position: 'relative', minHeight: layout.height, minWidth: minWidth - 80 }}>
        {network.blocks.map((block) => {
          const blockPosition = layout.positions.get(block.id) || { x: 20, y: 20 };
          return (
            <Box
              key={block.id}
              sx={{
                position: 'absolute',
                left: blockPosition.x,
                top: blockPosition.y,
                transition: 'all 0.3s ease'
              }}
            >
              {renderBlock(block, networkIndex)}
            </Box>
          );
        })}
      </Box>
    </Paper>
  ); };

  const declaredVariables = React.useMemo(() => {
    const map = new Map<string, { name: string; dataType: DataType; value: unknown }>();
    networks.forEach((network) => {
      network.blocks.forEach((block) => {
        if (block.type === 'INPUT') {
          const anchor = block.outputs[0];
          if (anchor?.name) map.set(anchor.name, { name: anchor.name, dataType: anchor.dataType, value: anchor.value });
        }
        if (block.type === 'OUTPUT') {
          const anchor = block.inputs[0];
          if (anchor?.name) map.set(anchor.name, { name: anchor.name, dataType: anchor.dataType, value: anchor.value });
        }
      });
    });
    return Array.from(map.values()).sort((a, b) => a.name.localeCompare(b.name));
  }, [networks]);

  const selectedTask = taskList[selectedTaskIndex];

  const handleOpen = () => {
    setRequiredLevel(String(Number(override?.design?.requiredLevel ?? 1000)));
    setError(null);
    setSuccess(null);
    setDialogOpen(true);
  };

  const handleClose = () => setDialogOpen(false);

  const handleConfirm = async () => {
    setSubmitting(true);
    setError(null);
    setSuccess(null);
    try {
      const val = parseInt(requiredLevel, 10);
      if (isNaN(val) || val < 0) {
        setError('Bitte eine gültige, nicht-negative Zahl eingeben.');
        setSubmitting(false);
        return;
      }
      const design = { ...(override?.design || {}), requiredLevel: val };
      await updateUnitContent(PAGE_ID, { design }, token!);
      await refresh();
      setSuccess('Mindestpunktzahl erfolgreich gespeichert.');
      setDialogOpen(false);
    } catch (e: any) {
      setError(e?.message || 'Speichern fehlgeschlagen.');
    } finally {
      setSubmitting(false);
    }
  };

  // Zugriffskontrolle: erst Permission, dann Punkte
  if (!canViewM10Fup) {
    return (
      <Box sx={{ p: 4 }}>
        <Alert severity="warning">
          Du hast keine Berechtigung, den FUP-Editor zu öffnen.
        </Alert>
        <Navigate to="/" replace />
      </Box>
    );
  }

  const canBypassScoreGate = canEditM10FupAccess || canEditM10FupNetworks || canEditM10FupBlocks;
  if (totalScore < currentRequired && !canBypassScoreGate) {
    return (
      <Box sx={{ p: 4 }}>
        <Alert severity="warning">
          Für dieses Modul benötigst du mindestens {currentRequired} Punkte. Deine aktuellen Punkte: {totalScore}
        </Alert>
        <Navigate to="/" replace />
      </Box>
    );
  }

  const taskTabs = (
    <Stack direction="row" alignItems="center" spacing={1}>
      <IconButton onClick={handlePrevTask} disabled={selectedTaskIndex === 0}>
        <PlaylistAddIcon sx={{ transform: 'rotate(180deg)' }} />
      </IconButton>
      <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
        Aufgabe {selectedTaskIndex + 1} / {taskList.length}
      </Typography>
      <IconButton onClick={handleNextTask} disabled={selectedTaskIndex === taskList.length - 1}>
        <PlaylistAddIcon />
      </IconButton>
    </Stack>
  );

  return (
    <UnitPageShell title={selectedTask.title} maxWidth={false}>
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', width: '100%', overflow: 'hidden' }}>
        <Box sx={{ position: 'sticky', top: 0, zIndex: 10, backgroundColor: tokens.colors.primary, width: '100%' }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ px: { xs: 1, sm: 2 }, py: 1, width: '100%' }}>
            <Typography variant="h6" sx={{ fontWeight: 600, color: tokens.colors.dark.text }}>
              FUP Editor
            </Typography>
            <Stack direction="row" spacing={1}>
              <IconButton onClick={handleOpenTasks} sx={{ color: tokens.colors.dark.text }}>
                <MenuBookIcon />
              </IconButton>
              <IconButton onClick={handleVariablesDialog} sx={{ color: tokens.colors.dark.text }}>
                <ListAltIcon />
              </IconButton>
              <IconButton onClick={handleValidateTask} sx={{ color: tokens.colors.dark.text }} title="Aufgabe prüfen" disabled={!canValidateM10FupTasks}>
                <CheckCircleIcon />
              </IconButton>
              <IconButton onClick={() => setInfoOpen(true)} sx={{ color: tokens.colors.dark.text }} title="Info-Center">
                <HelpOutlineIcon />
              </IconButton>
            </Stack>
          </Stack>
        </Box>

        <Box sx={{ px: { xs: 1, sm: 2 }, py: 1, display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            Aktuelle Mindestpunktzahl: {currentRequired} · Dein Punktestand: {totalScore}
          </Typography>
          {canEditM10FupAccess ? (
            <Button variant="contained" color="primary" onClick={handleOpen}>
              Mindestpunktzahl festlegen
            </Button>
          ) : (
            <Alert severity="info" sx={{ m: 0, px: 1.5, py: 0.5 }}>
              Nur berechtigte Nutzer können die Mindestpunktzahl ändern.
            </Alert>
          )}
        </Box>

        <Box
          sx={{
            backgroundColor: darkMode ? tokens.colors.dark.surfaceAlt : tokens.colors.light.surfaceAlt,
            borderBottom: `1px solid ${darkMode ? tokens.colors.dark.border : tokens.colors.light.border}`,
            width: '100%',
            overflow: 'hidden'
          }}
        >
          <Box sx={{ width: '100%', overflowX: 'hidden', overflowY: 'visible' }}>
            <Stack direction="row" spacing={0.75} alignItems="center" sx={{ px: { xs: 1, sm: 2 }, py: 1, minHeight: 56, flexWrap: 'wrap', width: '100%' }}>
              <IconButton draggable={!isSimulating && canEditM10FupBlocks} onDragStart={(event) => handleDragStart(event, 'INPUT')} sx={{ width: { xs: 40, sm: 48 }, height: { xs: 40, sm: 48 }, flexShrink: 0, p: 0.5 }} disabled={isSimulating || !canEditM10FupBlocks}>
                <FupInputIcon />
              </IconButton>
              <IconButton draggable={!isSimulating && canEditM10FupBlocks} onDragStart={(event) => handleDragStart(event, 'OUTPUT')} sx={{ width: { xs: 40, sm: 48 }, height: { xs: 40, sm: 48 }, flexShrink: 0, p: 0.5 }} disabled={isSimulating || !canEditM10FupBlocks}>
                <FupOutputIcon />
              </IconButton>
              <FormControl variant="standard" sx={{ minWidth: { xs: 100, sm: 140 }, flexShrink: 0 }}>
                <InputLabel id="function-select-label">Funktionsblock</InputLabel>
                <Select
                  labelId="function-select-label"
                  value={selectedFunction}
                  onChange={(event) => setSelectedFunction(event.target.value)}
                  disabled={isSimulating || !canEditM10FupBlocks}
                >
                  {Object.keys(blockCatalog).map((key) => (
                    <MenuItem key={key} value={key}>
                      {key}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText sx={{ color: darkMode ? tokens.colors.dark.textSecondary : tokens.colors.light.textSecondary }}>Zum Ziehen anklicken.</FormHelperText>
              </FormControl>
              <IconButton
                draggable={!isSimulating && canEditM10FupBlocks}
                onDragStart={(event) => handleDragStart(event, selectedFunction)}
                sx={{ width: { xs: 40, sm: 48 }, height: { xs: 40, sm: 48 }, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, p: 0.5 }}
                disabled={isSimulating || !canEditM10FupBlocks}
              >
                {blockCatalog[selectedFunction]?.svgComponent ? (
                  React.createElement(blockCatalog[selectedFunction].svgComponent!, { width: 48, height: 48 })
                ) : (
                  <Box component="img" src={blockCatalog[selectedFunction]?.icon ?? '/assets/drawable/zzz_help.png'} alt={selectedFunction} sx={{ width: '100%', height: '100%' }} />
                )}
              </IconButton>
              <Divider orientation="vertical" flexItem sx={{ flexShrink: 0 }} />
              <IconButton onClick={handleSimulateToggle} sx={{ backgroundColor: darkMode ? tokens.colors.dark.surface : tokens.colors.light.surface, width: { xs: 40, sm: 48 }, height: { xs: 40, sm: 48 }, flexShrink: 0, p: 0.5 }} disabled={!canUseM10FupSimulation}>
                {isSimulating ? <PauseIcon color="primary" fontSize="small" /> : <PlayArrowIcon color="primary" fontSize="small" />}
              </IconButton>
              <IconButton onClick={resetCanvas} sx={{ backgroundColor: darkMode ? tokens.colors.dark.surface : tokens.colors.light.surface, width: { xs: 40, sm: 48 }, height: { xs: 40, sm: 48 }, flexShrink: 0, p: 0.5 }} disabled={!canEditM10FupNetworks}>
                <RestartAltIcon color="error" fontSize="small" />
              </IconButton>
              <IconButton onClick={handleSave} sx={{ backgroundColor: darkMode ? tokens.colors.dark.surface : tokens.colors.light.surface, width: { xs: 40, sm: 48 }, height: { xs: 40, sm: 48 }, flexShrink: 0, p: 0.5 }} disabled={!canSaveM10FupProjects}>
                <SaveIcon color="primary" fontSize="small" />
              </IconButton>
              <IconButton onClick={handleLoadClick} sx={{ backgroundColor: darkMode ? tokens.colors.dark.surface : tokens.colors.light.surface, width: { xs: 40, sm: 48 }, height: { xs: 40, sm: 48 }, flexShrink: 0, p: 0.5 }} disabled={!canSaveM10FupProjects}>
                <PlaylistAddIcon sx={{ transform: 'rotate(90deg)' }} color="secondary" fontSize="small" />
              </IconButton>
              <IconButton onClick={handleAddNetwork} sx={{ backgroundColor: darkMode ? tokens.colors.dark.surface : tokens.colors.light.surface, width: { xs: 40, sm: 48 }, height: { xs: 40, sm: 48 }, flexShrink: 0, p: 0.5 }} disabled={isSimulating || !canEditM10FupNetworks}>
                <PlaylistAddIcon color="success" fontSize="small" />
              </IconButton>
              <input ref={fileInputRef} type="file" accept="application/json" style={{ display: 'none' }} onChange={handleLoadFile} />
            </Stack>
          </Box>
        </Box>

        <Box sx={{ flexGrow: 1, display: 'block', px: 0, py: 0, width: '100%' }}>
          <Box sx={{ width: '100%', maxWidth: '100%', position: 'relative', overflow: 'auto' }} ref={paperRef}>
            <Tabs value={selectedTaskIndex} onChange={(_event, value) => { setSelectedTaskIndex(value); resetCanvas(); }} sx={{ mb: 2 }} variant="scrollable" scrollButtons="auto">
              {taskList.map((task, index) => (
                <Tab key={task.title} label={`Aufgabe ${index + 1}`} />
              ))}
            </Tabs>
            <Paper sx={{ ...getCardSx(darkMode), p: 2.5, mb: 3 }}>
              <Typography variant="h6" sx={{ fontWeight: 700, color: darkMode ? tokens.colors.dark.text : tokens.colors.light.custom1, mb: 1 }}>
                {selectedTask.title}
              </Typography>
              <Typography variant="body1" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text, mb: 2 }}>
                {selectedTask.description}
              </Typography>
              
              <Stack spacing={1}>
                <Alert severity="info" icon={<HelpOutlineIcon />} sx={{ backgroundColor: darkMode ? tokens.colors.dark.accentSoft : tokens.colors.light.accentSoft, borderLeft: `4px solid ${darkMode ? tokens.colors.dark.accent : tokens.colors.light.accent}` }}>
                  <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>💡 Tipp zum Lösen:</Typography>
                  <Typography variant="body2">
                    Erstelle im Netzwerk die entsprechende Schaltung mit Eingängen (I1..I4), Funktionsblöcken und Ausgängen (Q1). 
                    Verwende den Play-Button zum Starten der Simulation, dann den Prüf-Button (✓), um deine Lösung automatisch zu testen.
                  </Typography>
                </Alert>
              </Stack>
            </Paper>
            {networks.map((network, index) => renderNetwork(network, index))}
            <svg style={{ position: 'absolute', top: 0, left: 0, pointerEvents: 'none', width: '100%', height: '100%' }}>
              {connections.map((connection) => {
                const geometry = linePositions[connection.id];
                if (!geometry) return null;
                const from = anchorFromId(connection.fromAnchorId);
                const isBool = from?.dataType === 'BOOL';
                const isTrue = Boolean(from?.value);
                const stroke = isSimulating && isBool && isTrue ? tokens.status.success : tokens.colors.primary;
                return (
                  <g key={connection.id} style={{ pointerEvents: 'auto', cursor: 'pointer' }} onContextMenu={(e) => {
                    e.preventDefault();
                    if (isSimulating) {
                      showSnackbar('Verbindungen sind im Simulationsmodus gesperrt.', 'warning');
                      return;
                    }
                    if (!canEditM10FupBlocks) {
                      showSnackbar('Keine Berechtigung zum Loeschen von Verbindungen.', 'warning');
                      return;
                    }
                    setConnections((prev) => prev.filter((c) => c.id !== connection.id));
                    showSnackbar('Verbindung gelöscht', 'success');
                  }}>
                    <line
                      x1={geometry.x1}
                      y1={geometry.y1}
                      x2={geometry.x2}
                      y2={geometry.y2}
                      stroke={stroke}
                      strokeWidth={2}
                      strokeLinecap="round"
                    />
                    {from && from.dataType !== 'BOOL' && (
                      (() => {
                        const mx = (geometry.x1 + geometry.x2) / 2;
                        const my = (geometry.y1 + geometry.y2) / 2 - 6;
                        const label = String(from.value);
                        return (
                          <g>
                            <text x={mx} y={my} textAnchor="middle" stroke={darkMode ? tokens.colors.dark.surface : tokens.colors.light.surface} strokeWidth={3} fontSize={12} fontFamily="Inter, Arial" paintOrder="stroke">
                              {label}
                            </text>
                            <text x={mx} y={my} textAnchor="middle" fill={darkMode ? tokens.colors.dark.text : tokens.colors.light.custom1} fontSize={12} fontFamily="Inter, Arial">
                              {label}
                            </text>
                          </g>
                        );
                      })()
                    )}
                  </g>
                );
              })}
            </svg>
          </Box>
        </Box>
      </Box>
      <Dialog open={taskDialogOpen} onClose={handleCloseTasks} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Aufgabenübersicht
          </Typography>
          <IconButton onClick={handleCloseTasks}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1, color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>
            {selectedTask.title}
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>
            {selectedTask.description}
          </Typography>
          {taskTabs}
        </DialogContent>
        <DialogActions>
          <Button onClick={handlePrevTask} disabled={selectedTaskIndex === 0}>
            Zurück
          </Button>
          <Button onClick={handleNextTask} disabled={selectedTaskIndex === taskList.length - 1}>
            Weiter
          </Button>
          <Button onClick={handleCloseTasks}>Schließen</Button>
        </DialogActions>
      </Dialog>

      {/* Info-Center */}
      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Stack direction="row" spacing={1} alignItems="center">
            <HelpOutlineIcon color="primary" />
            <Typography variant="h6" sx={{ fontWeight: 600 }}>Info-Center</Typography>
          </Stack>
          <IconButton onClick={() => setInfoOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Stack spacing={1.5}>
            <Typography variant="body1" sx={{ mb: 1, color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>
              Hier findest du eine kurze Anleitung zur Bedienung des FUP-Editors.
            </Typography>

            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography sx={{ fontWeight: 600, color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>Schnellstart</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Stack spacing={1}>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- Eingänge/Ausgänge über die Toolbar ziehen und ins gewünschte Netzwerk fallen lassen.</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- Funktionsblock wählen, Icon ziehen und ablegen (oder Quick-Add-Button nutzen).</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- Verbinde zuerst einen Ausgang, dann einen Eingang (Klick auf die runden Anker).</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- Doppelklick auf BOOL-Anker negiert das Signal (roter Kreis erscheint).</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- Simulation starten/stoppen mit Play/Pause.</Typography>
                </Stack>
              </AccordionDetails>
            </Accordion>

            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography sx={{ fontWeight: 600, color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>Funktionsbibliothek</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Stack spacing={1}>
                  <Typography variant="body2" sx={{ fontWeight: 600, color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>Logik:</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- AND/OR/XOR/NOT/NAND/NOR: Erweiterbar über +/− Buttons (min. 2 Eingänge).</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- SEL: Multiplexer mit Gate-Eingang (G=0→IN0, G=1→IN1).</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- SR/RS: Set-Reset-Latches (SR: Set prioritär; RS: Reset prioritär).</Typography>
                  <Typography variant="body2" sx={{ fontWeight: 600, mt: 1, color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>Edge/Flanken:</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- R_TRIG: Rising Edge (steigende Flanke); F_TRIG: Falling Edge (fallende Flanke).</Typography>
                  <Typography variant="body2" sx={{ fontWeight: 600, mt: 1, color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>Timer:</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- TON: Einschaltverzögerung; TOF: Ausschaltverzögerung; TP: Impulsgeber (Monoflop).</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- Alle Timer benötigen PT (Preset Time), DT (Delta Time pro Zyklus).</Typography>
                  <Typography variant="body2" sx={{ fontWeight: 600, mt: 1, color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>Zähler:</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- CTU: Aufwärts; CTD: Abwärts; CTUD: Auf-/Abwärts.</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- PV: Preset Value; CV: Current Value; R/LD: Reset/Load.</Typography>
                  <Typography variant="body2" sx={{ fontWeight: 600, mt: 1, color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>Arithmetik:</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- ADD, SUB, MUL, DIV: Grundrechenarten (DIV prüft Division durch 0).</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- ABS: Betrag; MIN/MAX/AVG: Minimum, Maximum, Durchschnitt.</Typography>
                  <Typography variant="body2" sx={{ fontWeight: 600, mt: 1, color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>Vergleiche:</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- GT (&gt;), GE (&gt;=), LE (&lt;=), EQ (==), NE (!=): Liefern BOOL.</Typography>
                  <Typography variant="body2" sx={{ fontWeight: 600, mt: 1, color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>Signalverarbeitung:</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- LIMIT: Begrenzt IN auf [MIN, MAX]; SCALE: Linear IN_MIN..IN_MAX → OUT_MIN..OUT_MAX.</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- HYST: Hysterese-Schalter (TH_ON/TH_OFF).</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- LPF: Low-Pass-Filter (TAU, DT); MOVAVG: Moving Average (N Samples).</Typography>
                  <Typography variant="body2" sx={{ fontWeight: 600, mt: 1, color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>Multiplexing:</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- MUX4: 4:1 Multiplexer (S0, S1 wählen IN0..IN3).</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- DEMUX4: 1:4 Demultiplexer (IN an OUT0..OUT3 je nach S0/S1).</Typography>
                  <Typography variant="body2" sx={{ fontWeight: 600, mt: 1, color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>Sonstiges:</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- PWM: Pulsweitenmodulation (DUTY 0..1, PERIOD, DT).</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- PID: PID-Regler (SP, PV, Kp, Ki, Kd, DT).</Typography>
                </Stack>
              </AccordionDetails>
            </Accordion>

            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography sx={{ fontWeight: 600, color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>Verdrahtung & Negation</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Stack spacing={1}>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- Fan‑out möglich: Ein Ausgang darf mehrere Eingänge speisen.</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- Eingänge bleiben single‑source (genau eine Quelle).</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- Im Simulationsmodus sind Verbindungsänderungen gesperrt.</Typography>
                  <Typography variant="body2" sx={{ fontWeight: 600, mt: 1, color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>Negation:</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- Doppelklick auf einen BOOL-Anker (Eingang/Ausgang) negiert das Signal.</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- Negierte Anker zeigen einen kleinen roten Kreis am Rand.</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- Negation wird beim Auswerten automatisch angewendet (NOT-Funktion).</Typography>
                </Stack>
              </AccordionDetails>
            </Accordion>

            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography sx={{ fontWeight: 600, color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>Simulation & Anzeige</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Stack spacing={1}>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- BOOL-Leitungen werden bei TRUE grün dargestellt.</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- Nicht-BOOL Signale zeigen ihren aktuellen Wert als Text nahe der Leitung.</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- Eingangs-BOOLs können im Simulationsmodus per Klick auf den Ausgangsanker getoggelt werden.</Typography>
                </Stack>
              </AccordionDetails>
            </Accordion>

            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography sx={{ fontWeight: 600, color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>Globale Variablen</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Stack spacing={1}>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- Gleichnamige IOs sind netzwerkübergreifend verbunden (z. B. Q3 in allen Netzwerken).</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- INPUT schreibt globale Werte; OUTPUT liest globale Werte.</Typography>
                </Stack>
              </AccordionDetails>
            </Accordion>

            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography sx={{ fontWeight: 600, color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>Aufgabenprüfung</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Stack spacing={1}>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- Über das Haken-Symbol wird die aktuelle Schaltung gegen Testvektoren geprüft.</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- Benenne IOs passend (I1..I4, Q1), damit die Prüfung deine Schaltung findet.</Typography>
                </Stack>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography sx={{ fontWeight: 600, color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>Legende</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Stack spacing={0.5}>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- SVG-Symbole: Alle Funktionsblöcke besitzen einheitliche SVG-Icons.</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- Runde Punkte: Anschlusspunkte (links: Eingänge, rechts: Ausgänge)</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- Port-Labels: Name und Datentyp stehen neben jedem Anschluss.</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- Tooltip: Maus über Anschluss zeigt Beschreibung.</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- Roter Kreis am Anker: Negiertes BOOL-Signal (NOT)</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- Rote Leitung: Signal FALSE/Standard</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- Grüne Leitung: BOOL = TRUE</Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>- Weißer Text auf Leitungen: Analoge Werte (INT, REAL)</Typography>
                </Stack>
              </AccordionDetails>
            </Accordion>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)}>Schließen</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={variableDialogOpen} onClose={closeVariablesDialog} maxWidth="sm" fullWidth>
        <DialogTitle>Deklarierte Variablen</DialogTitle>
        <DialogContent dividers>
          {declaredVariables.length === 0 ? (
            <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>Noch keine Variablen deklariert.</Typography>
          ) : (
            <Stack spacing={1}>
              {declaredVariables.map((variable) => (
                <Paper key={variable.name} sx={{ ...getCardSx(darkMode), p: 1.5, display: 'flex', justifyContent: 'space-between' }}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                    {variable.name}
                  </Typography>
                  <Typography variant="body2" sx={{ color: darkMode ? tokens.colors.dark.textSecondary : tokens.colors.light.textSecondary }}>
                    {variable.dataType} – {String(variable.value).toUpperCase()}
                  </Typography>
                </Paper>
              ))}
            </Stack>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={closeVariablesDialog}>Schließen</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={Boolean(ioDialog)} onClose={handleIoDialogClose} maxWidth="xs" fullWidth>
        <DialogTitle>{ioDialog?.type === 'INPUT' ? 'Eingang konfigurieren' : 'Ausgang konfigurieren'}</DialogTitle>
        <DialogContent dividers>
          <Stack spacing={2}>
            <TextField label="Name" value={ioName} onChange={(event) => setIoName(event.target.value)} fullWidth />
            <FormControl fullWidth>
              <InputLabel id="io-type-label">Datentyp</InputLabel>
              <Select
                labelId="io-type-label"
                value={ioType}
                label="Datentyp"
                onChange={(event) => setIoType(event.target.value as DataType)}
              >
                <MenuItem value="BOOL">BOOL</MenuItem>
                <MenuItem value="INT">INT</MenuItem>
                <MenuItem value="REAL">REAL</MenuItem>
                <MenuItem value="STRING">STRING</MenuItem>
                <MenuItem value="TIME">TIME</MenuItem>
              </Select>
            </FormControl>
            <TextField label="Initialwert" value={ioValue} onChange={(event) => setIoValue(event.target.value)} fullWidth />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleIoDialogClose}>Abbrechen</Button>
          <Button onClick={handleIoDialogSubmit} variant="contained" color="primary">
            Übernehmen
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={validationOpen} onClose={() => setValidationOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Stack direction="row" spacing={1} alignItems="center">
            <CheckCircleIcon color="primary" />
            <Typography variant="h6" sx={{ fontWeight: 600 }}>Automatische Schaltungsprüfung</Typography>
          </Stack>
          <IconButton onClick={() => setValidationOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {!validationResults || validationResults.length === 0 ? (
            <Typography variant="body2">Keine Testfälle vorhanden.</Typography>
          ) : (
            <Stack spacing={2}>
              <Typography variant="subtitle1" sx={{ fontWeight: 600, color: darkMode ? tokens.colors.dark.text : tokens.colors.light.custom1 }}>
                Aufgabe: "{taskList[selectedTaskIndex]?.title}"
              </Typography>

              {validationResults.map((r, idx) => {
                const inputStr = Object.keys(r.inputs)
                  .sort()
                  .map((k) => {
                    const val = r.inputs[k];
                    if (typeof val === 'boolean') return `${k}=${val ? '1' : '0'}`;
                    return `${k}=${val}`;
                  })
                  .join(', ');
                const expectedStr = typeof r.expected === 'boolean' ? (r.expected ? '1' : '0') : String(r.expected);
                const actualStr = typeof r.actual === 'boolean' ? (r.actual ? '1' : '0') : String(r.actual);
                const isPass = r.expected === r.actual;
                
                return (
                  <Paper key={idx} sx={{ p: 2, backgroundColor: isPass ? tokens.status.successSoft : tokens.status.errorSoft, border: `2px solid ${isPass ? tokens.status.success : tokens.status.error}` }}>
                    <Stack spacing={1}>
                      <Stack direction="row" alignItems="center" justifyContent="space-between">
                        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                          Testfall {idx + 1}/{validationResults.length}
                        </Typography>
                        {isPass ? (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: tokens.status.success, fontWeight: 600 }}>
                            <CheckCircleIcon fontSize="small" />
                            <Typography variant="caption" sx={{ fontWeight: 600 }}>✓ BESTANDEN</Typography>
                          </Box>
                        ) : (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: tokens.status.error, fontWeight: 600 }}>
                            <Box sx={{ display: 'inline-block', width: 18, height: 18, borderRadius: '50%', border: `2px solid ${tokens.status.error}` }}>
                              <Typography sx={{ textAlign: 'center', lineHeight: 1, fontSize: '12px', fontWeight: 700 }}>✕</Typography>
                            </Box>
                            <Typography variant="caption" sx={{ fontWeight: 600 }}>FEHLER</Typography>
                          </Box>
                        )}
                      </Stack>
                      
                      <Divider />
                      
                      <Stack direction="row" spacing={2} alignItems="center">
                        <Typography variant="body2" sx={{ fontWeight: 600, minWidth: 120 }}>Eingänge:</Typography>
                        <Typography variant="body2" sx={{ fontFamily: 'monospace', backgroundColor: darkMode ? tokens.colors.dark.surface : tokens.colors.light.surface, px: 1.5, py: 0.75, borderRadius: 1, border: `1px solid ${darkMode ? tokens.colors.dark.border : tokens.colors.light.border}`, flex: 1 }}>
                          {inputStr}
                        </Typography>
                      </Stack>
                      
                      <Stack direction="row" spacing={2} alignItems="center">
                        <Typography variant="body2" sx={{ fontWeight: 600, minWidth: 120 }}>Erwartet (Q1):</Typography>
                        <Box sx={{ 
                          fontFamily: 'monospace', 
                          backgroundColor: tokens.status.successSoft,
                          color: tokens.status.successText,
                          px: 1.5, 
                          py: 0.75, 
                          borderRadius: 1, 
                          fontWeight: 600,
                          border: `1px solid ${tokens.status.success}`
                        }}>
                          {expectedStr}
                        </Box>
                      </Stack>
                      
                      <Stack direction="row" spacing={2} alignItems="center">
                        <Typography variant="body2" sx={{ fontWeight: 600, minWidth: 120 }}>Aktuell (Q1):</Typography>
                        <Box sx={{ 
                          fontFamily: 'monospace', 
                          backgroundColor: isPass ? tokens.status.successSoft : tokens.status.errorSoft,
                          color: isPass ? tokens.status.successText : tokens.status.errorText,
                          px: 1.5, 
                          py: 0.75, 
                          borderRadius: 1, 
                          fontWeight: 600,
                          border: `1px solid ${isPass ? tokens.status.success : tokens.status.error}`
                        }}>
                          {actualStr}
                        </Box>
                      </Stack>
                    </Stack>
                  </Paper>
                );
              })}

              <Alert severity={validationResults.every(r => r.expected === r.actual) ? 'success' : 'error'}>
                {validationResults.every(r => r.expected === r.actual) ? (
                  <Stack spacing={0.5}>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>🎉 Alle Tests bestanden!</Typography>
                    <Typography variant="body2">
                      Deine Schaltung funktioniert korrekt. Klicke auf "Aufgabe abschließen" um die Punkte zu erhalten.
                    </Typography>
                  </Stack>
                ) : (
                  <Stack spacing={0.5}>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>⚠️ Einige Tests fehlgeschlagen</Typography>
                    <Typography variant="body2">
                      Überprüfe deine Schaltung und versuche es erneut. Kontrolliere die Eingänge und die Logik deiner Funktionsblöcke.
                    </Typography>
                  </Stack>
                )}
              </Alert>
            </Stack>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button onClick={() => setValidationOpen(false)} variant="outlined">
            Abbrechen
          </Button>
          <Button 
            onClick={() => {
              setValidationOpen(false);
              if (validationResults?.every(r => r.expected === r.actual)) {
                showSnackbar('✅ Hervorragend! Aufgabe erfolgreich abgeschlossen!', 'success');
              } else {
                showSnackbar('⚠️ Bitte überprüfe die fehlgeschlagenen Tests', 'warning');
              }
            }} 
            variant="contained" 
            color={validationResults?.every(r => r.expected === r.actual) ? 'success' : 'inherit'}
            startIcon={<CheckCircleIcon />}
          >
            Aufgabe abschließen
          </Button>
        </DialogActions>
      </Dialog>

      <AccessDialog
        open={dialogOpen}
        onClose={handleClose}
        onConfirm={handleConfirm}
        submitting={submitting}
        error={error}
        success={success}
        requiredLevel={requiredLevel}
        setRequiredLevel={setRequiredLevel}
      />

      <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={handleSnackbarClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} variant="filled" sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </UnitPageShell>
  );
};

const AccessDialog: React.FC<{ open: boolean; onClose: () => void; onConfirm: () => Promise<void>; submitting: boolean; error: string | null; success: string | null; requiredLevel: string; setRequiredLevel: (v: string) => void; }> = ({ open, onClose, onConfirm, submitting, error, success, requiredLevel, setRequiredLevel }) => {
  const { darkMode } = useTheme();
  
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Einstellungen: Zugangsvoraussetzung</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2, color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text }}>
          Beschreibung und Auswirkungen:
          - Die Mindestpunktzahl steuert den Zugriff auf diese Seite.
          - Nutzer ohne ausreichende Punkte sehen die Seite ggf. nicht im Menü bzw. erhalten keinen Zugriff.
          - Administratoren sind davon nicht betroffen.
        </Typography>
        <TextField
          label="Mindestpunktzahl"
          type="number"
          fullWidth
          value={requiredLevel}
          onChange={e => setRequiredLevel(e.target.value)}
          inputProps={{ min: 0 }}
        />
        {error && <Alert sx={{ mt: 2 }} severity="error">{error}</Alert>}
        {success && <Alert sx={{ mt: 2 }} severity="success">{success}</Alert>}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>Abbrechen</Button>
        <Button onClick={onConfirm} variant="contained" disabled={submitting}>Bestätigen</Button>
      </DialogActions>
    </Dialog>
  );
};

export default M10_U2_X1_FupUebung;
